import { i18n, MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

// NOTE: Avoid adding new strings here, prefer to use lingui to add them directly where used:
// const { t } = useLingui();
// t`Min text`

i18n.activate("en");

const MESSAGES: Record<string, MessageDescriptor> = {
  CUSTOMERS_SEARCH_500_ERROR_TITLE: msg`Ett fel har uppstått`,
  CUSTOMERS_SEARCH_500_ERROR_MESSAGE: msg`Testa igen och <a href=mailto:support@allears.ai class=alert-link>kontakta oss</a> om du behöver hjälp`,
  SHARE: msg`Dela`,
  EXPORT: msg`Exportera`,
  CUSTOMERS_REQUEST_TRANSCRIBE_SUCCESS_MESSAGE: msg`Avsnittet transkriberas`,

  CUSTOMERS_SENTIMENT_GRAPH_POSITIVE: msg`Positiva`,
  CUSTOMERS_SENTIMENT_GRAPH_NEGATIVE: msg`Negativa`,
  CUSTOMERS_SENTIMENT_GRAPH_NEUTRAL: msg`Neutrala`,
  CUSTOMERS_SENTIMENT_GRAPH_VERY_POSITIVE: msg`Väldigt positiva`,
  CUSTOMERS_SENTIMENT_GRAPH_VERY_NEGATIVE: msg`Väldigt negativa`,

  // Report app
  REPORTS_MAIN_TITLE: msg`Rapporter`,
  REPORTS_REPORT_SHARE: msg`Dela`,
  SHARE_TAG: msg`Dela tagg`,
  SHARE_WITH_KPIS: msg`Visa PR-värde och räckvidd`,
  SHARE_WITH_ALL_KPIS: msg`Visa PR-värde, sentiment och räckvidd`,
  REPORTS_QUICK_SUBSCRIBE: msg`Prenumerera`,
  REPORTS_QUICK_SUBSCRIBING: msg`Prenumererar`,
  REPORTS_QUICK_TITLE: msg`Mejla vid nya omnämnanden`,
  REPORTS_QUICK_TITLE_MONTHLY: msg`Mejla en sammanfattning`,
  REPORTS_REPORT_DELETE: msg`Radera rapporten`,
  REPORTS_REPORT_DELETE_CONFIRM: msg`Är du säker på att du vill ta bort den här rapporten?`,
  REPORTS_REPORT_TITLE_PLACEHOLDER: msg`Namn på rapporten`,

  // Report templates
  REPORT_LAST_MODIFIED: msg`Senast ändrad`,

  REPORTS_CREATE_OVERVIEW_BUTTON: msg`Överblick`,
  REPORTS_CREATE_OVERVIEW_DESCRIPTION: msg`Hur omnämns ni i media? Skapa en rapport som ger dig en översikt av hur ni omnämns och av vem.`,
  REPORTS_CREATE_COMPARISON_BUTTON: msg`Jämförelse`,
  REPORTS_CREATE_COMPARISON_DESCRIPTION: msg`Hur står sig ert varumärke mot era konkurrenter? Jämför era resultat och kvaliteten av omnämnanden över tid.`,
  REPORTS_CREATE_TIME_COMPARISON_BUTTON: msg`Tidsjämförelse`,
  REPORTS_CREATE_TIME_COMPARISON_DESCRIPTION: msg`Jämför en bevakning mot tidigare månad, kvartal eller år.`,
  REPORTS_CREATE_BLANK_BUTTON: msg`Skapa blank rapport`,

  REPORTS_TABLE_HEADERS_OVERVIEW: msg`Överblick`,
  REPORTS_TABLE_HEADERS_COMPARISON: msg`Jämförelse`,
  REPORTS_TABLE_HEADERS_TIME_COMPARISON: msg`Tidsjämförelse`,
  REPORTS_TABLE_HEADERS_BLANK: msg`Blank rapport`,

  REPORTS_CREATE_TIME_COMPARISON_MODAL_INTERVAL_LABEL: msg`Välj tidsinterval`,
  REPORTS_TIME_COMPARISON_INTERVALS_DAILY: msg`Dagsrapport`,
  REPORTS_TIME_COMPARISON_INTERVALS_WEEKLY: msg`Veckorapport`,
  REPORTS_TIME_COMPARISON_INTERVALS_MONTHLY: msg`Månadsrapport`,
  REPORTS_TIME_COMPARISON_INTERVALS_QUARTERLY: msg`Kvartalsrapport`,
  REPORTS_TIME_COMPARISON_INTERVALS_YEARLY: msg`Årsrapport`,

  SEARCH_SUBSCRIPTION_INTERVAL_REALTIME: msg`Direkt`,
  SEARCH_SUBSCRIPTION_INTERVAL_REALTIME_INSIGHTS_NEG: msg`Negativ påverkan`,
  SEARCH_SUBSCRIPTION_INTERVAL_REALTIME_INSIGHTS_POS: msg`Varumärkesbyggande`,
  SEARCH_SUBSCRIPTION_INTERVAL_REALTIME_INSIGHTS_HIGH_REACH: msg`Hög räckvidd`,
  SEARCH_SUBSCRIPTION_INTERVAL_DAILY: msg`Dagligen`,
  SEARCH_SUBSCRIPTION_INTERVAL_WEEKLY: msg`Varje vecka`,
  SEARCH_SUBSCRIPTION_INTERVAL_MONTHLY: msg`Varje månad`,
  SEARCH_SUBSCRIPTION_IMPORTANT_HEADER: msg`Viktiga omnämnanden`,
  SEARCH_SUBSCRIPTION_END: msg`Avsluta prenumeration`,

  REPORTS_CREATE_MODAL_CANCEL_BUTTON: msg`Avbryt`,
  REPORTS_CREATE_MODAL_SAVE_BUTTON: msg`Skapa rapport`,

  // Listing reports
  REPORTS_LIST_HEADER_INTERVAL: msg`Intervall`,
  REPORTS_LIST_HEADER_SUBSCRIBERS: msg`Mottagare`,
  REPORTS_LIST_SUBSCRIBERS_BADGE_REST_SINGULAR: msg`till`,
  REPORTS_LIST_SUBSCRIBERS_BADGE_REST_PLURAL: msg`till`,

  REPORTS_CANCEL: msg`Avbryt`,
  REPORTS_SAVE: msg`Spara rapport`,

  REPORTS_DOWNLOAD_PDF: msg`Ladda ned PDF`,
  REPORTS_HEADER_NAV_LANGUAGE: msg`Språk`,
  REPORTS_HEADER_NAV_CURRENCY: msg`Valuta`,

  REPORTS_HEADER_SUBSCRIBERS: msg`Markera vilka som ska få rapporten`,
  REPORTS_ALERT_SAVED: msg`Rapporten sparades`,
  REPORTS_ALERT_NOT_SAVED: msg`Rapporten kunde inte sparas`,

  REPORTS_SCHEDULE_SAVE_BUTTON: msg`Schemalägg utskick`,
  REPORTS_SCHEDULE_INTERVAL_LABEL: msg`Intervall för utskick`,
  REPORTS_SCHEDULE_HEADER: msg`Ställ in mailutskick av rapporten`,
  REPORTS_SCHEDULE_RECIPIENTS_HELP_TEXT: msg`Välj mottagare som ska få rapporten`,
  REPORTS_INTERVAL_NEVER: msg`Aldrig`,
  REPORTS_INTERVAL_REALTIME: msg`Direkt`,
  REPORTS_INTERVAL_DAILY: msg`Dagligen`,
  REPORTS_INTERVAL_WEEKLY: msg`Varje vecka`,
  REPORTS_INTERVAL_MONTHLY: msg`Varje månad`,
  REPORTS_INTERVAL_QUARTERLY: msg`Varje kvartal`,
  REPORTS_INTERVAL_YEARLY: msg`Varje år`,

  REPORTS_DATEPICKER_RANGE_7_DAYS: msg`Senaste 7 dag.`,
  REPORTS_DATEPICKER_RANGE_30_DAYS: msg`Senaste 30 dag.`,
  REPORTS_DATEPICKER_RANGE_3_MONTHS: msg`Senaste 3 mån.`,
  REPORTS_DATEPICKER_RANGE_6_MONTHS: msg`Senaste 6 mån.`,
  REPORTS_DATEPICKER_RANGE_12_MONTHS: msg`Senaste 12 mån.`,
  REPORTS_DATEPICKER_RANGE_PREV_YEAR: msg`Föregående år`,
  REPORTS_DATEPICKER_RANGE_YTD: msg`I år`,

  REPORTS_WIDGET_NEW_TITLE: msg`Ny widget`,
  REPORTS_WIDGET_EDIT_TITLE: msg`Redigera widget`,
  REPORTS_WIDGET_TITLE_LABEL: msg`Titel`,

  REPORTS_WIDGET_ENGAGEMENT_TWITTER_LIKE_COUNT: msg`X-likes`,
  REPORTS_WIDGET_ENGAGEMENT_TWITTER_RETWEET_COUNT: msg`X-retweets`,
  REPORTS_WIDGET_ENGAGEMENT_FACEBOOK_LIKE_COUNT: msg`Facebook-likes`,
  REPORTS_WIDGET_ENGAGEMENT_FACEBOOK_COMMENT_COUNT: msg`Facebook-kommentarer`,
  REPORTS_WIDGET_ENGAGEMENT_FACEBOOK_SHARE_COUNT: msg`Facebook-delningar`,
  REPORTS_WIDGET_ENGAGEMENT_FACEBOOK_REACTION_COUNT: msg`Facebook-reaktioner`,
  REPORTS_WIDGET_ENGAGEMENT_YOUTUBE_LIKE_COUNT: msg`Youtube-likes`,
  REPORTS_WIDGET_ENGAGEMENT_YOUTUBE_DISLIKE_COUNT: msg`Youtube-dislikes`,
  REPORTS_WIDGET_ENGAGEMENT_YOUTUBE_COMMENT_COUNT: msg`Youtube-kommentarer`,
  REPORTS_WIDGET_ENGAGEMENT_YOUTUBE_VIEW_COUNT: msg`Youtube-visningar`,
  REPORTS_WIDGET_ENGAGEMENT_TIKTOK_LIKE_COUNT: msg`Tiktok-likes`,
  REPORTS_WIDGET_ENGAGEMENT_TIKTOK_COMMENT_COUNT: msg`Tiktok-kommentarer`,
  REPORTS_WIDGET_ENGAGEMENT_TIKTOK_VIEW_COUNT: msg`Tiktok-visningar`,
  REPORTS_WIDGET_ENGAGEMENT_TIKTOK_SHARE_COUNT: msg`Tiktok-delningar`,
  REPORTS_WIDGET_ENGAGEMENT_INSTAGRAM_LIKE_COUNT: msg`Instagram-likes`,
  REPORTS_WIDGET_ENGAGEMENT_INSTAGRAM_COMMENT_COUNT: msg`Instagram-kommentarer`,
  REPORTS_WIDGET_ENGAGEMENT_INSTAGRAM_VIEW_COUNT: msg`Instagram-visningar`,
  REPORTS_WIDGET_ENGAGEMENT_LINKEDIN_COMMENT_COUNT: msg`LinkedIn-kommentarer`,
  REPORTS_WIDGET_ENGAGEMENT_LINKEDIN_REACTION_COUNT: msg`LinkedIn-reaktioner`,
  // Default titles
  REPORTS_WIDGET_DEFAULT_TITLE_NUM_MENTIONS_PIE: msg`Share of voice`,
  REPORTS_WIDGET_DEFAULT_TITLE_NUM_MENTIONS_BAR: msg`Omnämnanden över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_NUM_MENTIONS_LINE: msg`Omnämnanden över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_NUM_MENTIONS_AREA_STACKED: msg`Omnämnanden över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_NUM_MENTIONS_SUM: msg`Totalt antal omnämnanden`,
  REPORTS_WIDGET_DEFAULT_TITLE_ENGAGEMENT_LINE: msg`Engagemang över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_ENGAGEMENT_PIE: msg`Totalt engagemang`,
  REPORTS_WIDGET_DEFAULT_TITLE_ENGAGEMENT_SUM: msg`Engagemang`,
  REPORTS_WIDGET_DEFAULT_CLOSE_MODAL: msg`Stäng`,

  // Note: Some insights widget titles and subtitles are dubplicated in insights_report_powerpoint.py
  // and should be updated when these titles are changed. (Title and subtitle strings in: SLIDE_ATTRIBUTES_BY_WIDGET_METRIC
  REPORTS_WIDGET_DEFAULT_TITLE_NUM_CHANNELS_INSIGHTS: msg`Antal unika källor över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_NUM_MENTIONS_LINE_INSIGHTS: msg`Antal omnämnanden över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_PR_VALUE_LINE_INSIGHTS: msg`PR-värde över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_IMPACT_SCORE_INSIGHTS: msg`Inflytande`,
  REPORTS_WIDGET_DEFAULT_TITLE_IMPACT_SCORE_INSIGHTS_SUBTITLE: msg`Karta över källors räckvidd i kombination med sentimentet i deras omnämnanden`,
  REPORTS_WIDGET_DEFAULT_TITLE_MEDIA_TYPE_SHARE_INSIGHTS: msg`Antal omnämnanden per medietyp`,
  REPORTS_WIDGET_DEFAULT_TITLE_REACH_AUDIO_INSIGHTS: msg`Räckvidd över tid - Ljud`,
  REPORTS_WIDGET_DEFAULT_DESCRIPTION_REACH_AUDIO_INSIGHTS: msg`Så många nåddes i ljudmedia`,
  REPORTS_WIDGET_DEFAULT_TITLE_REACH_SOCIAL_INSIGHTS: msg`Räckvidd över tid - Sociala medier`,
  REPORTS_WIDGET_DEFAULT_DESCRIPTION_REACH_SOCIAL_INSIGHTS: msg`Så många nåddes i sociala medier`,
  REPORTS_WIDGET_DEFAULT_TITLE_TOTAL_REACH_OVER_TIME_INSIGHTS: msg`Total räckvidd över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_REACH_OVER_TIME_INSIGHTS: msg`Räckvidd över tid`,
  REPORTS_WIDGET_DEFAULT_DESCRIPTION_REACH_OVER_TIME_INSIGHTS: msg`Så många nåddes per mediekategori`,
  REPORTS_WIDGET_DEFAULT_TITLE_SENTIMENT_SHARE_INSIGHTS: msg`Sentimentfördelning`,
  REPORTS_WIDGET_DEFAULT_TITLE_SENTIMENT_PER_MEDIUM_INSIGHTS: msg`Sentiment över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_SENTIMENT_OVER_TIME_INSIGHTS: msg`Sentiment över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_FAVORITES_INSIGHTS: msg`Favoritomnämnanden`,
  REPORTS_WIDGET_DEFAULT_DESCRIPTION_FAVORITES_INSIGHTS: msg`Favoritmarkerade omnämnanden för den här bevakningen`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOP_CHANNELS_TABLE: msg`Flest omnämnanden`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOP_CHANNELS_TABLE_SUBTITLE: msg`Källor som nämnt sökorden flest gånger`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOP_MENTIONS_TABLE: msg`Toppträffar`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOP_MENTIONS_TABLE_SUBTITLE: msg`Omnämnanden med störst räckvidd`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOPICS: msg`Omnämnd i sammanhang`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOPICS_SUBTITLE: msg`Procentuell fördelning av ämnen`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOPICS_OVER_TIME: msg`Ämnen över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOPICS_OVER_TIME_SUBTITLE: msg`En indikation av vilka ämnen som trendat över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_WORD_CLOUD: msg`Ordmoln`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_WORD_CLOUD_SUBTITLE: msg`Dom här orden var populärast i bevakningen`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_WORD_CLOUD_TOGGLE_HASHTAGS: msg`Visa ord med hashtags`,
  REPORTS_WIDGET_PEST_INDEX_LEGEND: msg`Branschindex`,
  REPORTS_WIDGET_PEST_LEGEND: msg`Antal gånger du nämnts`,
  REPORTS_WIDGET_ALL_DATASETS_FILTER: msg`Alla`,

  REPORTS_WIDGET_DEFAULT_TITLE_SENTIMENT_SHARE_INSIGHTS_CENTER_LABEL: msg`Nettosentiment`,
  REPORTS_WIDGET_DEFAULT_TITLE_REACH_PIE: msg`Räckvidd fördelning`,
  REPORTS_WIDGET_DEFAULT_TITLE_REACH_BAR: msg`Räckvidd över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_REACH_LINE: msg`Räckvidd över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_REACH_AREA_STACKED: msg`Räckvidd över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_REACH_SUM: msg`Total räckvidd`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_MENTIONS_REACH_TABLE: msg`Mest inflytelserika`,
  REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_MENTIONS_REACH_TABLE_SUBTITLE: msg`Källor med störst räckvidd`,
  REPORTS_WIDGET_IMPACT_SCORE_X_MIN_LABEL: msg`Negativt`,
  REPORTS_WIDGET_IMPACT_SCORE_X_MAX_LABEL: msg`Positivt`,
  REPORTS_WIDGET_IMPACT_SCORE_Y_MIN_LABEL: msg`Lägre räckvidd`,
  REPORTS_WIDGET_IMPACT_SCORE_Y_MAX_LABEL: msg`Högre räckvidd`,

  REPORTS_WIDGET_DEFAULT_TITLE_POPULARITY_SCORE_PIE: msg`Popularitet fördelning`,
  REPORTS_WIDGET_DEFAULT_TITLE_POPULARITY_SCORE_BAR: msg`Popularitet över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_POPULARITY_SCORE_LINE: msg`Popularitet över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_POPULARITY_SCORE_AREA_STACKED: msg`Popularitet över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_POPULARITY_SCORE_SUM: msg`Popularitet`,

  REPORTS_WIDGET_DEFAULT_TITLE_PR_VALUE_PIE: msg`Pr-värde fördelning`,
  REPORTS_WIDGET_DEFAULT_TITLE_PR_VALUE_BAR: msg`Pr-värde över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_PR_VALUE_LINE: msg`Pr-värde över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_PR_VALUE_AREA_STACKED: msg`Pr-värde över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_PR_VALUE_SUM: msg`Totalt Pr-värde`,

  REPORTS_WIDGET_DEFAULT_TITLE_MEDIA_TYPES_PIE: msg`Medietyper fördelning`,
  REPORTS_WIDGET_DEFAULT_TITLE_MEDIA_TYPES_BAR: msg`Omnämnanden per medietyp över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_MEDIA_TYPES_LINE: msg`Omnämnanden per medietyp över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_MEDIA_TYPES_AREA_STACKED: msg`Omnämnanden per medietyp över tid`,
  REPORTS_WIDGET_DEFAULT_TITLE_SENTIMENT_PIE: msg`Sentiment`,
  REPORTS_WIDGET_DEFAULT_TITLE_SENTIMENT_LINE: msg`Sentiment över tid`,

  REPORTS_WIDGET_DEFAULT_TITLE_TOP_CHANNELS: msg`Flest omnämnanden`,
  REPORTS_WIDGET_DEFAULT_TITLE_TOPICS: msg`Omnämnd i sammanhang`,
  REPORTS_WIDGET_DEFAULT_TITLE_MENTIONS: msg`Mest relevanta omnämnanden`,
  REPORTS_WIDGET_DEFAULT_TITLE_WORD_CLOUD: msg`Ordmoln`,

  REPORTS_WIDGET_METRIC_LABEL: msg`Mätvärde`,
  REPORTS_WIDGET_CHART_TYPE_LABEL: msg`Diagramtyp`,
  REPORTS_WIDGET_ALERTS_LABEL: msg`Källor`,
  REPORTS_WIDGET_SORTING_POSITION_LABEL: msg`Sortering`,
  REPORTS_WIDGET_SORTING_POSITION_HELP_TEXT: msg`Genom att ändra värdet kan du välja i vilken ordning som din widget visas.`,
  REPORTS_WIDGET_ERROR_LABEL: msg`Något gick fel. Prova att ladda om sidan.`,
  REPORTS_WIDGET_NO_DATA_LABEL: msg`Ingen data tillgänglig under denna tidsperiod.`,
  REPORTS_WIDGET_WORKING_LABEL: msg`Datan bearbetas, ladda om rapporten om stund.`,
  REPORTS_WIDGET_IS_PROCESSING_FOOTER: msg`Datan bearbetas fortfarande och blir tillgänglig allt eftersom`,
  REPORTS_WIDGET_ERROR_MENTIONS_WIDGET_NO_SOURCES: msg`Välj minst en källa.`,
  REPORTS_WIDGET_ERROR_MENTIONS_WIDGET_MULTIPLE_SOURCE_TYPES: msg`Denna widget måste ha bevakningar eller en tagg som källa, inte båda samtidigt.`,
  REPORTS_WIDGET_ERROR_MENTIONS_WIDGET_MULTIPLE_TAGS: msg`Denna widget kan endast ha en tagg åt gången.`,
  REPORTS_WIDGET_IS_COMPACT_LABEL: msg`Kompakt utseende`,
  REPORTS_WIDGET_IS_COMPACT_HELP_TEXT: msg`Kompakta widgets är mindre och gjorda för positioneras längst upp i rapporten.`,
  REPORTS_WIDGET_METRIC_TYPE_NUM_MENTIONS: msg`Antal omnämnanden`,
  REPORTS_WIDGET_METRIC_TYPE_PR_VALUE: msg`PR-värde`,
  REPORTS_WIDGET_METRIC_TYPE_REACH: msg`Räckvidd`,
  REPORTS_WIDGET_METRIC_TYPE_TONALITY: msg`Sentiment`,
  REPORTS_WIDGET_METRIC_TYPE_TOP_CHANNELS: msg`Flest omnämnanden`,
  REPORTS_WIDGET_METRIC_TYPE_TOPICS: msg`Ämnen`,
  REPORTS_WIDGET_METRIC_TYPE_MEDIA_TYPES: msg`Antal omnämnanden per medietyp`,
  REPORTS_WIDGET_METRIC_TYPE_MENTIONS: msg`Mest relevanta omnämnanden`,
  REPORTS_WIDGET_METRIC_TYPE_ENGAGEMENT: msg`Engagemang`,
  REPORTS_WIDGET_METRIC_TYPE_POPULARITY_SCORE: msg`Popularitet`,
  REPORTS_WIDGET_METRIC_TYPE_WORD_CLOUD: msg`Ordmoln`,

  REPORTS_WIDGET_CHART_TYPE_LINE: msg`Linje`,
  REPORTS_WIDGET_CHART_TYPE_CIRCLE: msg`Cirkel`,
  REPORTS_WIDGET_CHART_TYPE_AREA_STACKED: msg`Yta`,
  REPORTS_WIDGET_CHART_TYPE_BAR: msg`Stapel`,
  REPORTS_WIDGET_CHART_TYPE_SUM: msg`Summering`,

  REPORTS_WIDGET_SOURCES_ACTIVE_ALERTS_GROUP_HEADER: msg`Bevakningar`,
  REPORTS_WIDGET_SOURCES_EXPIRED_ALERTS_GROUP_HEADER: msg`Avslutade bevakningar`,
  REPORTS_WIDGET_SOURCES_TAGS_GROUP_HEADER: msg`Taggar`,
  REPORTS_WIDGET_SOURCES_SAVED_MENTIONS_GROUP_HEADER: msg`Sparade omnämnanden`,
  REPORTS_WIDGET_SOURCES_HELP_TEXT: msg`Välj vilka källor denna widget ska hämta data från.`,
  REPORTS_WIDGET_SOURCES_ALERTS_LOADING_SUFFIX: msg`laddar…`,
  REPORTS_WIDGET_SOURCES_FAVORITE_OPTION: msg`Favoriter`,

  REPORTS_WIDGET_DELETE: msg`Ta bort`,
  REPORTS_WIDGET_SAVE: msg`Spara widget`,
  REPORTS_WIDGET_CANCEL: msg`Avbryt`,

  REPORTS_WIDGET_METRIC_DURING: msg`under senaste`,

  // SUM chart type
  REPORTS_MENTION_WIDGET_METRIC_SINGULAR: msg`omnämnande`,
  REPORTS_MENTION_WIDGET_METRIC_PLURAL: msg`omnämnanden`,

  REPORTS_TOP_CHANNEL_WIDGET_LOADING: msg`Laddar…`,
  REPORTS_TOP_CHANNEL_WIDGET_MENTION_SINGULAR: msg`omnämnande`,
  REPORTS_TOP_CHANNEL_WIDGET_MENTION_PLURAL: msg`omnämnanden`,
  REPORTS_TOP_CHANNEL_WIDGET_REACH_PER_WEEK: msg`Räckvidd per vecka:`,

  REPORTS_SCHEDULE_SCHEDULED_BUTTON_LABEL: msg`Ändra mottagare`,
  REPORTS_SCHEDULE_SCHEDULED_SINGULAR_BUTTON_LABEL: msg`1 mottagare`,
  REPORTS_SCHEDULE_SCHEDULED_PLURAL_BUTTON_LABEL: msg`mottagare`,
  REPORTS_SCHEDULE_NOT_SCHEDULED_BUTTON_LABEL: msg`Lägg till mottagare`,
  REPORTS_SCHEDULE_SMALL_SCREENS_BUTTON_LABEL: msg`Mottagare`,

  REPORTS_TIME_COMPARISON_COMPARED_WITH: msg`jämfört med`,

  // Insights report Table chart
  SEARCH_TOP_WIDGET_TITLE_REACH: msg`Räckvidd`,
  SEARCH_TOP_WIDGET_TITLE_MENTIONS: msg`Omnämnanden`,
  SEARCH_TOP_WIDGET_TITLE_EPISODES_SINGULAR: msg`i 1 inlägg`,
  SEARCH_TOP_WIDGET_TITLE_EPISODES_PLURAL: msg`i {} inlägg`,
  SEARCH_TOP_WIDGET_TITLE_PR_VALUE: msg`PR-värde`,
  SEARCH_TOP_WIDGET_TITLE_SENTIMENT: msg`Sentiment`,
  SEARCH_TOP_WIDGET_TITLE_NET_SENTIMENT: msg`Nettosentiment`,
  SEARCH_TOP_WIDGET_TITLE_POWERPOINT: msg`Analys`,
  SEARCH_TOP_WIDGET_TITLE_POWERPOINT_DOWNLOAD_READY: msg`Klicka för att ladda ner`,
  SEARCH_TOP_WIDGET_TITLE_POWERPOINT_DOWNLOAD: msg`Exportera analys som PowerPoint`,
  SEARCH_TOP_WIDGET_TITLE_POWERPOINT_ERROR: msg`Någonting gick fel, försök igen.`,
  SEARCH_TOP_WIDGET_TITLE_POWERPOINT_LOADING: msg`Genererar PowerPoint`,
  SEARCH_TOP_WIDGET_TITLE_POWERPOINT_TITLE: msg`Ladda ner`,
  SEARCH_TOP_WIDGET_COMPARISON: msg`mot tidigare period`,
  SEARCH_TOP_WIDGET_PREVIOUS_PERIOD: msg`Tidigare period:`,
  SEARCH_TOP_WIDGET_INSIGHT_SUMMARY_TITLE: msg`Höjdpunkter senaste veckan`,
  // Insights report Table chart
  REPORTS_WIDGET_REACH_TABLE_SOURCE: msg`Källa`,
  REPORTS_WIDGET_REACH_TABLE_REACH: msg`Räckvidd`,
  REPORTS_WIDGET_REACH_TABLE_MEDIA: msg`Medietyp`,
  REPORTS_WIDGET_REACH_TABLE_MENTIONS: msg`Omnämnanden`,

  REPORTS_WIDGET_UNKNOWN_SOURCE_NAME: msg`Källa saknar namn`,

  // Insights PEST widget
  REPORTS_WIDGET_PEST_TITLE: msg`PEST-analys`,
  REPORTS_WIDGET_PEST_DESCRIPTION: msg`Så här mycket pratas det i ljudmedier inom områdena politik, ekonomi, samhälle och teknologi`,
  // Navigation
  NAV_DASHBOARD: msg`Dashboard`,
  NAV_REPORTS: msg`Rapporter`,
  NAV_SEARCH: msg`Arkivsök`,

  NAV_ACCOUNT_SETTINGS: msg`Inställningar`,
  NAV_ACCOUNT_LOGOUT: msg`Logga ut`,

  NAV_CREATE_NEW_ALERT: msg`Skapa ny bevakning`,
  NAV_TAGS: msg`Taggar`,
  NAV_ARCHIVE: msg`Arkiv`,
  NAV_FAVORITE_ALERTS: msg`Favoriter`,
  NAV_ACTIVE_ALERTS: msg`Bevakningar`,
  NAV_SAVED_MENTIONS: msg`Sparade sökningar`,
  NAV_EXPIRED_ALERTS: msg`Avslutade bevakningar`,
  CREATE_NEW_ALERT_DISABLED_INFO_TEXT_BEGINNING: msg`Ni har nått kontots gräns på`,
  CREATE_NEW_ALERT_DISABLED_INFO_TEXT_MIDDLE: msg`Hör av dig till oss via vår`,
  CREATE_NEW_ALERT_DISABLED_INFO_TEXT_CHAT: msg`chatt`,
  CREATE_NEW_ALERT_DISABLED_INFO_TEXT_END: msg`så hjälper vi er!`,
  NAV_CREATE_NEW_ALERT_DISABLED_ALERT_PLURAL: msg`bevakningar.`,
  NAV_CREATE_NEW_ALERT_DISABLED_ALERT_SINGULAR: msg`bevakning.`,
  NAV_UPGRADE_TITLE: msg`Du använder gratis-versionen av All Ears.`,
  NAV_UPGRADE_DESC: msg`Lås upp bevakningar med fullständig täckning av talade medier, insikter och mer.`,
  NAV_UPGRADE_CTA: msg`Uppgradera`,
  ALERT_CREATED_BY: msg`Skapad av`,
  ALERT_NO_MENTIONS: msg`Det finns inga träffar som matchar din sökning.`,
  ALERT_NO_MENTIONS_FILTERED: msg`Nollställ filtret eller ändra din sökning.`,
  ALERT_NO_MENTIONS_TIME_PERIOD: msg`Det finns inga träffar under vald period.`,
  ALERT_NO_MENTIONS_TIME_PERIOD_SUB: msg`Visa alla`,
  ALERT_NO_MENTIONS_YET: msg`Just nu lyssnar vi efter omnämnanden för den här bevakningen`,
  ALERT_NO_MENTIONS_YET_SUB: msg`Så fort vi hör något dyker det upp här eller i din inkorg`,
  ALERT_NO_MENTIONS_LINK: msg`Vill du ändra dina inställningar av hur ofta du får mejlrapporter <a href='/a/settings/?subscriptions=true'>kan du göra det här</a>`,
  ALERT_NO_MENTIONS_GENERIC_ERROR: msg`Hoppsan! Någonting gick snett`,
  ALERT_NO_MENTIONS_GENERIC_ERROR_SUB: msg` Försök igen om en liten stund`,
  ALERT_FILTERED_FEED_NOTICE_TITLE: msg`Inga fler omnämnanden för den här tidsperioden.`,
  ALERT_FILTERED_FEED_NOTICE_LINK: msg`Klicka här för att visa alla omnämnanden.`,
  ALERT_FILTERED_FEED_LIMITATION_TITLE: msg`Vi hittade {} omnämnanden`,
  ALERT_FILTERED_FEED_LIMITATION_CTA: msg`Uppgradera din plan`,
  ALERT_FILTERED_FEED_LIMITATION_TEXT: msg`för att se alla omnämnanden, skapa en bevakning, djupdyka i analyser och få notiser när ditt sökord omnämns.`,
  ALERT_LOOKING_FOR_NEW_MENTIONS: msg`Söker efter nya omnämnanden.`,

  MENTIONS_REACH_HOW_CALCULATED: msg`Så här har vi räknat ut räckvidd`,
  MENTIONS_NET_SENTIMENT_INFO: msg`Läs mer om nettosentiment`,
  MENTIONS_PEST_MORE_INFO: msg`Vad är en PEST-analys?`,
  MENTIONS_PR_VALUE: msg`PR-värde:`,
  MENTIONS_PR_VALUE_HOW_CALCULATED: msg`Så här har vi räknat ut PR-värde`,
  MENTIONS_PR_VALUE_CURRENCY_SHOWN: msg`Valutan visas i`,
  MENTIONS_POPULARITY_HOW_CALCULATED: msg`Så här har vi räknat ut popularitet`,
  MENTIONS_NET_SENTIMENT_HOW_CALCULATED: msg`Läs mer om nettosentiment`,
  MENTIONS_IMPACT_SCORE_HOW_CALCULATED: msg`Läs mer om inflytande`,
  HELP_ARTICLE_IMPACT_SCORE: msg`https://help.allears.ai/sv/articles/9203996-hur-fungerar-inflytande`,
  MENTIONS_EDIT_EDITING: msg`Redigerar`,
  MENTIONS_EDIT_BAR_SAVE: msg`Spara`,
  MENTIONS_EDIT_BAR_CANCEL: msg`Avbryt`,
  MENTIONS_CONTEXT_PAYWALLED: msg`Träff i en artikel som kräver inloggning för att läsa.`,
  MENTIONS_MARK_AS_FAVORITE: msg`Favorit`,
  MENTIONS_SHARE: msg`Dela`,
  MENTIONS_SHARE_COPY_TO_CLIPBOARD: msg`Kopiera länk`,
  MENTIONS_SHARE_COPY_TO_CLIPBOARD_SUCCESS: msg`Länken kopierades!`,
  MENTIONS_SHARE_COPY_TO_CLIPBOARD_FAILED: msg`Länken kunde inte kopieras`,
  COPY_TO_CLIPBOARD: msg`Kopiera till urklipp`,
  COPY_TO_CLIPBOARD_FAILED: msg`Kunde inte kopieras`,
  MENTIONS_PLAYER_COUNT_OF: msg`av`,
  MENTIONS_PLAYER_GENERIC_ERROR: msg`Någonting gick fel med uppspelningen`,
  MENTIONS_REMOVE_MENTION: msg`Ta bort`,

  SAVED_SEARCH_MENTIONS_INITIALIZING: msg`Vi sparar ditt sökresultat`,
  SAVED_SEARCH_MENTIONS_INITIALIZING_CREATING: msg`Vi är strax klara!`,
  MENTIONS_INITIALIZING: msg`Din bevakning är skapad!`,
  MENTIONS_INITIALIZING_CREATING: msg`Vi lyssnar efter omnämnanden och skapar en analys. Vi är strax klara!`,
  MENTIONS_MARKED_AS_IRRELEVANT_REVERT: msg`Ångra`,
  MENTIONS_SHOW_ORIGINAL: msg`Original`,
  MENTIONS_SHOW_TRANSLATION: msg`Översätt`,

  MENTIONS_UNDO_INDIVIDUAL: msg`Vi har tagit bort det här omnämnandet`,
  MENTIONS_REMOVED_SOURCE: msg`Vi kommer inte att visa fler omnämnanden från {show}`,
  MENTIONS_CHANNEL_GENERIC: msg`kanalen`,
  MENTIONS_REMOVED_ALL_MENTIONS: msg`Vi har tagit bort hela inlägget`,
  MENTIONS_NOT_INTERESTING: msg`Inte intressant`,
  MENTIONS_REMOVE_ALL_MENTIONS: msg`Ta bort hela inlägget`,
  MENTIONS_REMOVE_SOURCE: msg`Visa inte kanalen igen`,

  MENTIONS_SHOW_FULL_EPISODE_DESCRIPTION: msg`Visa avsnittets beskrivning`,
  MENTIONS_SHOW_SHORT_EPISODE_DESCRIPTION: msg`Visa mindre`,
  MENTIONS_SHOW_FULL_TRANSCRIPT: msg`Visa hela transkriptet`,
  MENTIONS_EDIT_MENTION: msg`Redigera omnämnande`,
  MENTIONS_TRANSCRIBE_EPISODE: msg`Transkribera inlägg`,
  MENTIONS_TRANSCRIBE_IN_PROGRESS: msg`Avsnittet transkriberas`,
  MENTIONS_VIEW_IN_ADMIN: msg`Visa träff i admin`,
  EPISODE_VIEW_IN_ADMIN: msg`Visa avsnitt i admin`,
  CHANNEL_VIEW_IN_INTERNAL: msg`Visa källa`,
  MENTIONS_ANCHOR_LINK: msg`Kopiera direktlänk`,
  MENTIONS_SENTIMENT_TONE: msg`Sentiment`,
  MENTIONS_SENTIMENT_EDIT_TONE: msg`Redigera sentiment`,
  MENTIONS_SENTIMENT_TONE_POSITIVE: msg`Positivt`,
  MENTIONS_SENTIMENT_TONE_NEUTRAL: msg`Neutralt`,
  MENTIONS_SENTIMENT_TONE_NEGATIVE: msg`Negativt`,
  MENTIONS_SENTIMENT_TONE_VERY_POSITIVE: msg`Väldigt positivt`,
  MENTIONS_SENTIMENT_TONE_VERY_POSITIVE_PLURAL: msg`Väldigt positiva`,
  MENTIONS_SENTIMENT_TONE_VERY_NEGATIVE: msg`Väldigt negativt`,
  MENTIONS_SENTIMENT_TONE_VERY_NEGATIVE_PLURAL: msg`Väldigt negativa`,

  MENTIONS_SENTIMENT_POSITIVE: msg`Positiv`,
  MENTIONS_SENTIMENT_NEUTRAL: msg`Neutral`,
  MENTIONS_SENTIMENT_NEGATIVE: msg`Negativ`,

  MENTIONS_SENTIMENT_TONE_POSITIVE_PLURAL: msg`positiva`,
  MENTIONS_SENTIMENT_TONE_NEUTRAL_PLURAL: msg`neutrala`,
  MENTIONS_SENTIMENT_TONE_NEGATIVE_PLURAL: msg`negativa`,

  MENTIONS_SENTIMENT_TONE_PROCESSING: msg`Sentiment analyseras…`,
  MENTIONS_SENTIMENT_TOOLTIP_MOST_OF_ONE: msg`{most} av {total} omnämnanden är {sentiment} i det här inlägget`,
  MENTIONS_SENTIMENT_TOOLTIP_MIXED: msg`Blandade sentiment, lika många är positiva som negativa`,
  MENTIONS_SENTIMENT_TOOLTIP_UNANIMOUS: msg`Alla omnämnanden är {sentiment}`,
  MENTIONS_ARE_PROCESSED_INFO_ALERT: msg`Bevakningen bearbetas just nu, så all data visas inte än.`,
  MENTIONS_TAGS_NO_OPTIONS: msg`Skriv namnet på din tagg`,
  MENTIONS_TAGS_CREATE_NEW: msg`Skapa taggen`,
  MENTIONS_TAGS_TITLE: msg`Tagga`,
  MENTIONS_TAGS_TITLE_FOCUSED: msg`Välj tagg eller skriv för att skapa en ny`,
  MENTIONS_TAGS_TAG_DELETE: msg`Radera tagg`,
  MENTIONS_TAGS_TAG_CONFIRM_DELETION: msg`Är du säker på att du vill ta bort den här taggen?`,
  MENTIONS_TAGS_TAG_CONFIRM_DELETION_CTA: msg`Radera`,
  MENTIONS_TAGS_TAG_TITLE: msg`Tagg`,

  MENTIONS_SIMILAR_LINK_PLURAL: msg`liknande omnämnanden`,
  MENTIONS_SIMILAR_LINK_SINGULAR: msg`liknande omnämnande`,
  MENTIONS_SIMILAR_NEWS_LINK_PLURAL: msg`Publicerad i {} andra källor`,
  MENTIONS_SIMILAR_NEWS_LINK_SINGULAR: msg`Publicerad i 1 annan källa`,

  MENTIONS_COLLAPSED_LINK_PLURAL: msg`ytterligare omnämnanden`,
  MENTIONS_COLLAPSED_LINK_SINGULAR: msg`ytterligare omnämnande`,

  MENTIONS_ENGAGEMENT_LIKES_LABEL: msg`Likes`,
  MENTIONS_ENGAGEMENT_DISLIKES_LABEL: msg`Dislikes`,
  MENTIONS_ENGAGEMENT_COMMENTS_LABEL: msg`Kommentarer`,
  MENTIONS_ENGAGEMENT_VIEWS_LABEL: msg`Visningar`,
  MENTIONS_ENGAGEMENT_SHARES_LABEL: msg`Delningar`,
  MENTIONS_ENGAGEMENT_RETWEETS_LABEL: msg`Retweets`,
  MENTIONS_ENGAGEMENT_REACTIONS_LABEL: msg`Reaktioner`,

  TOPLIST_BADGE_ON: msg`på`,

  HIGH_REACH_MENTION_BADGE: msg`Hög räckvidd`,
  HIGH_REACH_MENTION_BADGE_TOOLTIP: msg`Högre räckvidd än vanligt i denna bevakning`,
  TOPLIST_MENTIONS_BADGE: msg`100 på Apple iTunes`,
  TOPLIST_MENTIONS_BADGE_TOOLTIP: msg`Från Apple iTunes topplista för podcasts`,
  NEGATIVE_IMPACT_MENTIONS_BADGE: msg`Negativ påverkan`,
  NEGATIVE_IMPACT_MENTIONS_BADGE_TOOLTIP: msg`Inlägget är negativt, från en inflytelserik källa och innehåller flera omnämnanden`,
  POSITIVE_IMPACT_MENTIONS_BADGE: msg`Varumärkesbyggande`,
  POSITIVE_IMPACT_MENTIONS_BADGE_TOOLTIP: msg`Inlägget är positivt, från en inflytelserik källa och innehåller flera omnämnanden`,
  NEW_RECORD_BADGE: msg`Nytt rekord`,
  NEW_RECORD_BADGE_TOOLTIP: msg`Nytt rekord för den här bevaknignen`,

  MOST_MENTIONS_BADGE: msg`Ökade omnämnanden`,
  MOST_MENTIONS_BADGE_TOOLTIP: msg`Antalet omnämnanden har ökat i den här bevakningen`,
  MOST_SOURCE_BADGE: msg`Ökade källor`,
  MOST_SOURCE_BADGE_TOOLTIP: msg`Fler unika källor nämner sökorden i den här bevakningen`,
  MENTIONS_KARAOKE_CLIP: msg`av transkriptet skippat`,

  MENTIONS_VIEW_HEADER: msg`Omnämnanden`,
  MENTIONS_VIEW_NO_HITS: msg`Inga omnämnanden hittades.`,

  // mentions/MentionsView
  MENTIONS_VIEW_INTRO_MENTIONS_SINGULAR: msg`omnämnande`,
  MENTIONS_VIEW_INTRO_MENTIONS_PLURAL: msg`omnämnanden`,
  MENTIONS_VIEW_INTRO_IN: msg`i`,
  MENTIONS_VIEW_INTRO_EPISODES: msg`olika inlägg`,

  // Mention toolbar and filters
  MENTIONS_VIEW_TOOLBAR_FILTER_TITLE: msg`Filtrera & sortera`,
  MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_DATE: msg`Nyast först`,
  MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_RELEVANCE: msg`Mest relevant först`,
  MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_REACH: msg`Högst räckvidd först`,
  MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_POPULARITY: msg`Populärast först`,
  MENTIONS_VIEW_TOOLBAR_EDIT: msg`Ändra`,

  MENTIONS_VIEW_TOOLBAR_EXPORT_EXCEL: msg`Exportera till Excel`,
  MENTIONS_VIEW_TOOLBAR_EXPORT_CSV: msg`Exportera till CSV`,
  MENTIONS_VIEW_TOOLBAR_EXPORT_POWERPOINT: msg`Exportera till PowerPoint`,
  MENTIONS_VIEW_TOOLBAR_EXPORT_JSON_API: msg`Länk till API`,
  MENTIONS_VIEW_TOOLBAR_EXPORT_RSS: msg`Länk till RSS`,
  MENTIONS_VIEW_TOOLBAR_EXPORT_LINK: msg`Delbar länk`,

  MENTIONS_VIEW_TOOLBAR_UPSALE_TOOLTIP: msg`Den här funktionen är ett tillval, klicka här för att chatta med oss om att uppgradera ert abonnemang`,
  MENTIONS_VIEW_TOOLBAR_EXPORT_EXCEL_FEATURE: msg`Hej! Jag är intresserad av att höra mer om Excel-exporter?`,
  MENTIONS_VIEW_TOOLBAR_EXPORT_JSON_API_FEATURE: msg`Hej! Jag är intresserad av att höra mer om API-tillgång?`,
  MENTIONS_VIEW_FILTER_BUTTON: msg`Filter`,
  MENTIONS_VIEW_TOOLBAR_FILTER_INSIGHT_TYPES: msg`Insikter`,
  MENTIONS_VIEW_TOOLBAR_FILTER_CHANNEL_TYPE_LABEL: msg`Medietyp`,
  MENTIONS_VIEW_TOOLBAR_FILTER_CHANNEL_NAME_LABEL: msg`Källa`,
  MENTIONS_VIEW_TOOLBAR_FILTER_CHANNEL_NAME_SEARCH_PLACEHOLDER: msg`Skriv för att söka bland {} källor`,
  MENTIONS_VIEW_TOOLBAR_FILTER_CHANNEL_NAME_SEARCH_NO_RESULTS: msg`Inga resultat`,
  MENTIONS_VIEW_TOOLBAR_FILTER_SENTIMENT_LABEL: msg`Sentiment`,
  MENTIONS_VIEW_TOOLBAR_FILTER_SORTING_LABEL: msg`Sortering`,
  MENTIONS_VIEW_TOOLBAR_FILTER_CATEGORIES_LABEL: msg`Ämne`,
  MENTIONS_VIEW_TOOLBAR_FILTER_DATES_LABEL: msg`Datum`,
  MENTIONS_VIEW_TOOLBAR_FILTER_LANGUAGES_LABEL: msg`Språk`,
  MENTIONS_VIEW_TOOLBAR_FILTER_FREETEXT_PLACEHOLDER: msg`Sök bland omnämnanden`,
  MENTIONS_VIEW_TOOLBAR_FILTER_FREETEXT_TOOLTIP: msg`Sök`,
  MENTIONS_VIEW_TOOLBAR_FILTER_MIN_REACH_THRESHOLD_PLACEHOLDER: msg`Minsta räckvidd`,
  MENTIONS_VIEW_TOOLBAR_FILTER_FILTER_BUTTON_LABEL: msg`Filtrera`,
  MENTIONS_VIEW_TOOLBAR_FILTER_RESET_BUTTON_LABEL: msg`Nollställ filter`,
  MENTIONS_VIEW_TOOLBAR_FILTER_MIN_REACH_HELP: msg`Räckvidd är ett estimat för hur många personer som har nåtts av ett omnämnande.`,
  MENTIONS_VIEW_TOOLBAR_FILTER_MIN_REACH_HELP_LINK_TEXT: msg`Läs mer om hur vi har räknat ut räckvidd här.`,
  MENTIONS_VIEW_TOOLBAR_FILTER_LOADING_OPTIONS: msg`Laddar filteralternativ...`,
  MENTIONS_VIEW_TOOLBAR_FILTER_LOADING_OPTIONS_ERROR: msg`Misslyckades att ladda filteralternativ.`,
  MENTIONS_VIEW_TOOLBAR_FILTER_LOADING_OPTIONS_RETRY: msg`Försök igen`,
  MENTIONS_VIEW_TOOLBAR_FILTER_CHANNEL_NAME_SEARCH_CAP_INFO: msg`Visar {} sökresultat. Specificera din sökning för att se fler.`,
  MENTIONS_VIEW_RESET_MENTIONS: msg`Ta bort befintliga omnämnanden`,
  MENTIONS_VIEW_TOOLBAR_DELETE_SEARCH: msg`Radera`,
  MENTIONS_VIEW_CONFIRM_DELETE_SEARCH: msg`Detta kommer att radera hela bevakningen, inklusive omnämnanden. Är du säker?`,
  EDIT_SUBSCRIPTIONS_MODAL_HEADER: msg`Mailutskick för`,

  MENTIONS_WILL_REMOVE: msg`Det här kommer att ta bort`,
  MENTIONS_ALL_EXISTING: msg`alla befintliga`,
  MENTIONS_PLURAL: msg`omnämnanden`,
  CHANNELS_PLURAL: msg`Källor`,
  MENTIONS_SINGULAR: msg`omnämnande`,
  MENTIONS_WILL_CREATE_NEW: msg`Nya omnämnanden kommer sedan skapas baserat på hur bevakningen är gjord.`,
  MENTIONS_CONFIRM: msg`Är du säker på att du vill gå vidare?`,
  MENTIONS_RESET_HEADER: msg`Vill du ta bort befintliga omnämnanden?`,

  INVITE_WIZARD_INVITE_SENT: msg`Vi har skickat en inbjudan till`,
  INVITE_WIZARD_NEW_INVITE: msg`Bjud in en kollega till`,

  MENTIONS_VIEW_MENTIONS_COUNT_SINGULAR: msg`omnämnande`,
  MENTIONS_VIEW_MENTIONS_COUNT_PLURAL: msg`omnämnanden`,

  MENTION_LIST_BREAKPOINT_TODAY: msg`Idag`,
  MENTION_LIST_BREAKPOINT_YESTERDAY: msg`Igår`,
  MENTION_LIST_BREAKPOINT_LAST_WEEK: msg`Senaste veckan`,
  MENTION_LIST_BREAKPOINT_EARLIER: msg`Äldre än en vecka`,

  MENTIONS_VIEW_PAGINATION_PAGE: msg`Sida`,
  MENTIONS_VIEW_PAGINATION_OF: msg`av`,

  // mentions/MentionToolbar
  MENTIONS_VIEW_HIDDEN_HEADER: msg`Borttagna omnämnanden`,
  MENTIONS_VIEW_HIDDEN_LIST_HEADER_IRRELEVANT_AT: msg`Borttaget`,
  MENTIONS_VIEW_HIDDEN_LIST_HEADER_IRRELEVANT_BY: msg`Borttaget av`,
  MENTIONS_VIEW_HIDDEN_LIST_HEADER_IRRELEVANT_REASON: msg`Borttaget anledning`,
  MENTIONS_VIEW_HIDDEN_IRRELEVANT_REASON: msg`Irrelevant`,
  MENTIONS_VIEW_HIDDEN_INCORRECT_REASON: msg`Felaktig`,
  MENTIONS_VIEW_HIDDEN_EXCLUDED_TOPIC_REASON: msg`Exkluderat ämne`,
  MENTIONS_VIEW_HIDDEN_EXCLUDED_SOURCE_REASON: msg`Borttagen källa`,
  MENTIONS_VIEW_UNHIDDEN_ACTION: msg`Omnämnandet är nu synligt igen`,
  MENTIONS_NEWS_VIEW_ALL_MENTIONS: msg`Alla {} omnämnanden i artikeln`,

  MENTIONS_EXTERNAL_LINK_SHOW: msg`Visa på`,
  MENTIONS_EXTERNAL_LINK_LISTEN: msg`Fortsätt lyssna på`,
  MENTIONS_EXTERNAL_LINK_WATCH: msg`Visa på`,
  MENTIONS_EXTERNAL_LINK_READ: msg`Läs hela artikeln på`,
  MENTIONS_EXTERNAL_LINK_READ_LOCALLY: msg`Läs hela artikeln`,
  MENTIONS_AUDIO_UNAVAILABLE: msg`Ljudet för det här avsnittet är inte längre tillgängligt i All Ears, men du kan lyssna direkt i källan.`,

  MENTIONS_POPULARITY_SCORE_TITLE: msg`Popularitet`,
  MENTIONS_POPULARITY_SCORE_EXPLANATION: msg`Vår uppskattning av podcastens popularitet (0-100)`,
  MENTIONS_ENGAGEMENT_SCORE_ENGAGEMENT_TITLE: msg`Engagemang`,
  MENTIONS_ENGAGEMENT_SCORE_REACTIONS_TITLE: msg`Reaktioner`,
  MENTIONS_ENGAGEMENT_SCORE_EXPLANATION: msg`Engagemang är en summering av antalet interaktioner med ett inlägg i sociala medier, såsom kommentarer, delningar och likes`,
  INSIGHT_TOPLIST_MENTIONS_PLURAL: msg`<u>{} nya omnämnanden</u> på iTunes topplista för podcasts.`,
  INSIGHT_TOPLIST_MENTIONS: msg`<u>Ett nytt omnämnande</u> på iTunes topplista för podcasts.`,
  INSIGHT_HIGH_REACH_MENTION_PLURAL: msg`<u>Det här omnämnandet</u> hade extra hög räckvidd.`,
  INSIGHT_HIGH_REACH_MENTION: msg`<u>Det här omnämnandet</u> hade extra hög räckvidd.`,
  INSIGHT_POSITIVE_IMPACT_PLURAL: msg`<u>{} nya inlägg</u> är varumärkesbyggande.`,
  INSIGHT_POSITIVE_IMPACT: msg`<u>Ett nytt inlägg</u> är varumärkesbyggande.`,
  INSIGHT_NEGATIVE_IMPACT_PLURAL: msg`<u>{} nya inlägg</u> har negativ påverkan.`,
  INSIGHT_NEGATIVE_IMPACT: msg`<u>Ett nytt inlägg</u> har negativ påverkan.`,
  INSIGHT_MOST_MENTIONS_PLURAL: msg`<u>{} nya omnämnanden</u> förra veckan, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS: msg`<u>Ett nytt omnämnande</u> förra veckan, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_FACEBOOK_PLURAL: msg`<u>{} nya omnämnanden</u> på Facebook, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_FACEBOOK: msg`<u>Ett nytt omnämnande</u> på Facebook, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_INSTAGRAM_PLURAL: msg`<u>{} nya omnämnanden</u> på Instagram, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_INSTAGRAM: msg`<u>Ett nytt omnämnande</u> på Instagram, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TWITTER_PLURAL: msg`<u>{} nya omnämnanden</u> på X, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TWITTER: msg`<u>Ett nytt omnämnande</u> på X, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_LINKEDIN_PLURAL: msg`<u>{} nya omnämnanden</u> på LinkedIn, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_LINKEDIN: msg`<u>Ett nytt omnämnande</u> på LinkedIn, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_PODCAST_PLURAL: msg`<u>{} nya omnämnanden</u> i podcasts, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_PODCAST: msg`<u>Ett nytt omnämnande</u> i podcasts, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_RADIO_PLURAL: msg`<u>{} nya omnämnanden</u> i radio, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_RADIO: msg`<u>Ett nytt omnämnande</u> i radio, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TIKTOK_PLURAL: msg`<u>{} nya omnämnanden</u> på TikTok, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TIKTOK: msg`<u>Ett nytt omnämnande</u> på TikTok, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TV_PLURAL: msg`<u>{} nya omnämnanden</u> på TV, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TV: msg`<u>Ett nytt omnämnande</u> på TV, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_YOUTUBE_PLURAL: msg`<u>{} nya omnämnanden</u> på YouTube, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_YOUTUBE: msg`<u>Ett nytt omnämnande</u> på YouTube, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_NEWS_PLURAL: msg`<u>{} nya omnämnanden</u> i nyhetsartiklar, det är flest hittills!`,
  INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_NEWS: msg`<u>Ett nytt omnämnande</u> i nyhetsartiklar, det är flest hittills!`,
  INSIGHT_MORE_MENTIONS_THAN_USUAL_PLURAL: msg`Antalet nya omnämnanden har <u>ökat med {}&#37;</u>.`,
  INSIGHT_MORE_MENTIONS_THAN_USUAL: msg`Antalet nya omnämnanden har <u>ökat med {}&#37;</u>.`,
  INSIGHT_MORE_CHANNELS_THAN_USUAL_PLURAL: msg`<u>{}&#37; ökning</u> av nya omnämnanden i unika källor.`,
  INSIGHT_MORE_CHANNELS_THAN_USUAL: msg`<u>{}&#37; ökning</u> av nya omnämnanden i unika källor.`,
  LANG_EN: msg`Engelska`,
  LANG_SV: msg`Svenska`,
  LANG_NO: msg`Norska`,
  LANG_DE: msg`Tyska`,
  LANG_DA: msg`Danska`,
  LANG_FI: msg`Finska`,
  LANG_ES: msg`Spanska`,
  LANG_FR: msg`Franska`,
  LANG_IT: msg`Italienska`,
  LANG_NL: msg`Nederländska`,
  LANG_PT: msg`Portugisiska`,

  ENTITY_TYPE_COMPANY: msg`företag`,
  ENTITY_TYPE_PERSON: msg`person`,
  ENTITY_TYPE_BRAND: msg`varumärke`,

  SOURCE_SUBTYPE_INSTAGRAM_STORY: msg`Instagram Story`,
  SOURCE_SUBTYPE_INSTAGRAM_VIDEO: msg`Instagram Reel`,

  MENTIONS_QUERYBUILDER_UPDATE_DISCLAIMER: msg`Dina ändringar kommer att tillämpas på kommande omnämnanden.`,

  MENTIONS_QUERYBUILDER_TITLE_LABEL: msg`Titel`,
  MENTIONS_QUERYBUILDER_TITLE_PLACEHOLDER: msg`Namn på din bevakning`,
  MENTIONS_QUERYBUILDER_START_DATE_LABEL: msg`Historik`,
  MENTIONS_QUERYBUILDER_END_DATE_LABEL: msg`Slutdatum`,
  MENTIONS_QUERYBUILDER_END_DATE_PLACEHOLDER: msg`Tills vidare`,
  MENTIONS_QUERYBUILDER_PREVIEW_BUTTON: msg`Förhandsvisa`,
  MENTIONS_QUERYBUILDER_UPDATE_BUTTON: msg`Spara ändringar`,
  MENTIONS_QUERYBUILDER_CONTINUE_BUTTON: msg`Fortsätt`,
  MENTIONS_QUERYBUILDER_MODAL_TITLE: msg`Färdigställ bevakning`,
  MENTIONS_QUERYBUILDER_MODAL_CLOSE: msg`Avbryt`,
  MENTIONS_QUERYBUILDER_SAVE_BUTTON: msg`Starta bevakning`,
  MENTIONS_QUERYBUILDER_MODAL_TYPE_LABEL: msg`Vad ska du bevaka?`,
  MENTIONS_QUERYBUILDER_MODAL_TYPE_PLACEHOLDER: msg`Välj från listan`,
  MENTIONS_QUERYBUILDER_START_DATE_PLACEHOLDER: msg`Automatisk`,

  MENTIONS_QUERYBUILDER_SEARCH_TYPE_BRAND: msg`Eget varumärke, verksamhet eller företag`,
  MENTIONS_QUERYBUILDER_SEARCH_TYPE_INDUSTRY_OR_AREA_OF_INTEREST: msg`Bransch / Intresseområde`,
  MENTIONS_QUERYBUILDER_SEARCH_TYPE_COMPETITORS: msg`Konkurrenter`,
  MENTIONS_QUERYBUILDER_SEARCH_TYPE_CAMPAIGN_OR_PROJECT: msg`Kampanjer / Projekt`,
  MENTIONS_QUERYBUILDER_SEARCH_TYPE_KEY_PEOPLE: msg`Nyckelpersoner`,
  MENTIONS_QUERYBUILDER_SEARCH_TYPE_OTHER: msg`Annat`,
  MENTIONS_QUERYBUILDER_SEARCH_TYPE_ERROR: msg`Du måste välja en bevakningstyp`,
  MENTIONS_QUERYBUILDER_INDUSTRY_LABEL: msg`Branschindex (använd ej)`,
  MENTIONS_QUERYBUILDER_INDUSTRY_NONE: msg`Inget`,
  MENTIONS_QUERYBUILDER_INDUSTRY_HELP: msg`Ange endast ifall bevakningen ska ingå i ett branschindex`,
  MENTIONS_QUERYBUILDER_PREVIEW_MENTIONS_SINGULAR: msg`omnämnande`,
  MENTIONS_QUERYBUILDER_PREVIEW_MENTIONS_PLURAL: msg`omnämnanden`,
  MENTIONS_QUERYBUILDER_PREVIEW_HEADER: msg`den senaste månaden.`,
  MENTIONS_QUERYBUILDER_PREVIEW_TEXT_PRE: msg`Bevakningen uppskattas ge i snitt`,
  MENTIONS_QUERYBUILDER_PREVIEW_TEXT_POST: msg`i månaden`,

  MENTIONS_QUERYBUILDER_PREVIEW_NO_RESULTS_HEADER: msg`Inga träffar den senaste månaden`,
  MENTIONS_QUERYBUILDER_PREVIEW_NO_RESULTS_TEXT: msg`Testa att justera sökorden och försök igen.`,
  MENTIONS_QUERYBUILDER_ADD_OPTION_PLACEHOLDER: msg`Lägg till`,
  MENTIONS_QUERYBUILDER_ADD_OPTION_BUTTON: msg`Lägg till`,
  MENTIONS_QUERYBUILDER_FILTER_AND_JOINER: msg`och`,
  MENTIONS_QUERYBUILDER_FILTER_MORE_SUFFIX: msg`till`,
  MENTIONS_QUERYBUILDER_FILTER_SELECT_ALL: msg`Markera alla`,
  MENTIONS_QUERYBUILDER_ADD_MORE_CLAUSES: msg`Lägg till söksats`,
  MENTIONS_QUERYBUILDER_EDIT_SUBSCRIPTIONS_BUTTON: msg`Hantera mailutskick`,
  MENTIONS_QUERYBUILDER_FILTER_KEYWORDS_LABEL: msg`Sökord`,
  MENTIONS_QUERYBUILDER_FILTER_KEYWORDS_PLACEHOLDER: msg`Skriv in sökord att bevaka`,
  MENTIONS_QUERYBUILDER_FILTER_KEYWORDS_HELP: msg`Exempelvis: varumärken, konkurrenter, talespersoner eller branschbegrepp`,
  MENTIONS_QUERYBUILDER_FILTER_LANGUAGES_SHORT: msg`Språk:`,
  MENTIONS_QUERYBUILDER_FILTER_LANGUAGES_LONG: msg`Språk`,
  MENTIONS_QUERYBUILDER_FILTER_SOURCES_SHORT: msg`Medietyper:`,
  MENTIONS_QUERYBUILDER_FILTER_SOURCES_LONG: msg`Medietyper`,
  MENTIONS_QUERYBUILDER_FILTER_SOURCES_PLACEHOLDER: msg`Skriv namn på källa`,
  MENTIONS_QUERYBUILDER_FILTER_TOPICS_PLACEHOLDER: msg`Skriv namn på ämnet`,
  MENTIONS_QUERYBUILDER_FILTER_MIN_REACH_HELP: msg`Lägsta räckvidd för träffar. Noll betyder att alla träffar visas, oavsett räckvidd.`,
  MENTIONS_QUERYBUILDER_AUTO_TAG_SHORT: msg`Taggar:`,
  MENTIONS_QUERYBUILDER_AUT_TAG_LONG: msg`Tagga omnämnanden automatiskt`,
  MENTIONS_QUERYBUILDER_AUTO_TAG_PLACEHOLDER: msg`Skriv taggnamn`,

  MENTIONS_QUERYBUILDER_FILTER_NEAR_KEYWORDS_SHORT: msg`I närheten av sökord:`,
  MENTIONS_QUERYBUILDER_FILTER_NEAR_KEYWORDS_LONG: msg`I närheten av sökord`,
  MENTIONS_QUERYBUILDER_FILTER_NEAR_KEYWORDS_PLACEHOLDER: msg`Ord att inkludera`,
  MENTIONS_QUERYBUILDER_FILTER_NEAR_NEAR_KEYWORDS_PLACEHOLDER: msg`Ord att inkludera`,
  MENTIONS_QUERYBUILDER_FILTER_NOT_NEAR_KEYWORDS_SHORT: msg`Ej i närheten av sökord:`,
  MENTIONS_QUERYBUILDER_FILTER_NOT_NEAR_KEYWORDS_LONG: msg`Ej i närheten av sökord`,
  MENTIONS_QUERYBUILDER_FILTER_NOT_NEAR_KEYWORDS_PLACEHOLDER: msg`Ord att exkludera`,
  MENTION_SETTING_FOR: msg`Inställningar för`,
  MENTION_SETTING_SHOW_SEARCH: msg`Visa bevakning`,
  MENTION_SETTING_GENERAL: msg`Ändra bevakning`,
  MENTION_SETTING_HIDDEN_MENTIONS: msg`Visa borttagna omnämnanden`,
  MENTION_SETTING_REMOVE: msg`Radera bevakning`,
  MENTION_SETTING_TITLE: msg`Inställningar`,
  MENTION_SETTING_REMOVE_MODAL_TITLE: msg`Radera`,
  MENTION_SETTING_SEARCH: msg`Bevakning`,
  MENTION_SETTING_LOADING: msg`Laddar`,
  MENTION_SETTING_SAVE_CHANGES: msg`Spara ändringar`,
  MENTION_SETTING_CANCEL_CHANGES: msg`Avbryt`,
  MENTION_SETTING_REFRESH_ALERT: msg`Ladda om bevakning`,
  MENTION_SETTING_REFRESH_ALERT_DISCLAIMER: msg`Varning detta tar bort alla tidigare resultat`,
  ADD_USER: msg`Bjud in en kollega`,
  ADD_USER_TEXT: msg`Låt en kollega ta del av omnämnanden, mailrapporter och analyser.`,
  MENTIONS_QUERYBUILDER_TEMPLATE_TITLE: msg`Bevakningsmall`,
  MENTIONS_QUERYBUILDER_TEMPLATE_APPLY: msg`Välj mall`,
  MENTIONS_QUERYBUILDER_TEMPLATE_SELECT_PLACEHOLDER: msg`Välj mall från listan`,
  MENTIONS_QUERYBUILDER_TEMPLATE_OVERRIDE_WARNING: msg`Du har gjort ändringar i din bevakning, de kommer att skrivas över om du väljer att använda en mall.`,
  MENTIONS_QUERYBUILDER_FILTER_INCLUDE_CHANNEL_NAMES_SHORT: msg`Endast i källor:`,
  MENTIONS_QUERYBUILDER_FILTER_INCLUDE_CHANNEL_NAMES_LONG: msg`Endast i källor`,
  MENTIONS_QUERYBUILDER_FILTER_EXCLUDE_CHANNEL_NAMES_SHORT: msg`Exkludera källor:`,
  MENTIONS_QUERYBUILDER_FILTER_EXCLUDE_CHANNEL_NAMES_LONG: msg`Exkludera källor`,
  MENTIONS_QUERYBUILDER_FILTER_EXCLUDE_TOPICS_SHORT: msg`Exkludera ämnen:`,
  MENTIONS_QUERYBUILDER_FILTER_EXCLUDE_TOPICS_LONG: msg`Exkludera ämnen`,
  MENTIONS_QUERYBUILDER_FILTER_EXCLUDE_MIN_REACH_SHORT: msg`Minsta räckvidd:`,
  MENTIONS_QUERYBUILDER_FILTER_EXCLUDE_MIN_REACH_LONG: msg`Minsta räckvidd`,
  MENTIONS_QUERYBUILDER_FILTER_MENTION_TYPES_SHORT: msg`Omnämnandetyp:`,
  MENTIONS_QUERYBUILDER_FILTER_MENTION_TYPES_LONG: msg`Typ av omnämnande`,
  MENTIONS_QUERYBUILDER_FILTER_INCLUDE_PAYWALLED_SHORT: msg`Inkludera ofullständiga betalväggsträffar`,
  MENTIONS_QUERYBUILDER_FILTER_INCLUDE_PAYWALLED_LONG: msg`Inkludera ofullständiga betalväggsträffar`,
  MENTIONS_QUERYBUILDER_FILTER_DISTANCE: msg`Maximalt ordavstånd:`,
  MENTIONS_QUERYBUILDER_FILTER_SORTING_POSITION: msg`Sortering`,
  MENTIONS_QUERYBUILDER_FILTER_SORTING_POSITION_HELP: msg`Ange bevakningens ordning i menyn och mailutskick. Lägre värde sorteras högre upp.`,
  MENTIONS_QUERYBUILDER_FILTER_ADD_NEAR_NEAR_FIELD: msg`+ I närheten av`,
  MENTIONS_QUERYBUILDER_FILTER_NEAR_NEAR_FIELD: msg`och`,

  MENTIONS_QUERYBUILDER_FILTER_MENTION_TYPE_SPEECH: msg`Endast träffar i tal`,
  MENTIONS_QUERYBUILDER_FILTER_MENTION_TYPE_TEXT: msg`Endast träffar i text`,
  MENTIONS_QUERYBUILDER_CREATE_SUCCESSFUL: msg`Bevakningen skapades`,
  MENTIONS_QUERYBUILDER_SAVE_SUCCESSFUL: msg`Bevakningen sparades`,
  MENTIONS_QUERYBUILDER_SAVE_FAILED: msg`Bevakningen kunde inte sparas`,
  MENTIONS_QUERYBUILDER_SAVE_FAILED_500: msg`Någonting gick fel, försök igen.`,
  MENTIONS_QUERYBUILDER_SAVE_FAILED_FAILING_FIELDS: msg`Följande fält har fel:`,
  MENTIONS_QUERYBUILDER_SAVE_FAILED_QUERY: msg`Söksats`,

  MENTIONS_QUERYBUILDER_PREVIEW_GENERIC_ERROR: msg`Något gick fel i förhandsvisningen, försök gärna igen.`,
  MENTIONS_QUERYBUILDER_PREVIEW_TIMEOUT_ERROR: msg`Förhandsvisningen tog för lång tid att genomföra. Prova att göra din bevakning mer specifik.`,
  MENTIONS_QUERYBUILDER_REQUIRED_QUERY_LANGUAGES_FILTER_EMPTY_ERROR: msg`Du måste välja minst ett språk att bevaka`,
  MENTIONS_QUERYBUILDER_REQUIRED_QUERY_SOURCES_FILTER_EMPTY_ERROR: msg`Du måste välja minst en medietyp att bevaka`,
  MENTIONS_QUERYBUILDER_NEWS_LABEL: msg`Nyheter`,
  MENTIONS_QUERYBUILDER_AUDIO_LABEL: msg`Ljud`,
  MENTIONS_QUERYBUILDER_SOCIAL_LABEL: msg`Sociala medier`,

  MENTIONS_QUERYBUILDER_NEW_SEARCH: msg`Ny bevakning`,
  MENTIONS_QUERYBUILDER_COPY_SETTINGS: msg`Duplicera inställningar`,
  MENTIONS_QUERYBUILDER_COPY_SETTINGS_FAILED: msg`Inga inställningar att duplicera`,
  MENTIONS_QUERYBUILDER_FILTER_NEAR_KEYWORDS_HELP_TEXT: msg`Något av orden måste förekomma i närheten`,
  MENTIONS_QUERYBUILDER_FILTER_NOT_NEAR_KEYWORDS_HELP_TEXT: msg`Ord som inte får förekomma i närheten`,
  MENTIONS_QUERYBUILDER_FILTER_MAX: msg`Högst`,
  MENTIONS_QUERYBUILDER_FILTER_WORDS_APART: msg`ord bort från sökorden`,

  MENTIONS_QUERYBUILDER_MENTIONED_TOGETHER_WITH: msg`Nämns i samband med`,
  MENTIONS_QUERYBUILDER_NOT_MENTIONED_TOGETHER_WITH: msg`Uteslut ord`,

  MENTION_QUERYBUILDER_NEAR_KEYWORD_ADD_CUSTOM: msg`Lägg till`,
  MENTION_QUERYBUILDER_NEAR_KEYWORD_SUGGESTION_HEADER: msg`Förfina din sökning med sambandsord`,
  MENTION_QUERYBUILDER_IF_NO_NEAR_KEYWORD_SUGGESTION_TEXT: msg`För att smalna av din sökning kan du lägga till egna sambandsord. Minst ett av orden måste förekomma i närheten av din sökning.`,
  MENTIONS_FULL_TRANSCRIPT_MODAL_DOWNLOAD: msg`Ladda ner`,

  CONFIRM_ACTION: msg`Bekräfta`,
  CANCEL_ACTION: msg`Avbryt`,

  TRANSCRIPTION_STATUS_QUEUED: msg`Köad för transkribering`,
  TRANSCRIPTION_STATUS_FAILED: msg`Transkribering misslyckades`,
  TRANSCRIPTION_STATUS_ONGOING: msg`Transkribering pågår...`,
  TRANSCRIPTION_STATUS_NOT_TRANSCRIBED: msg`Ej transkriberad`,

  // Account page
  ACCOUNT_VIEW_ACCOUNT_HEADER: msg`Abonnemangsinformation`,
  ACCOUNT_VIEW_ACCOUNT_PLAN: msg`Plan`,
  ACCOUNT_VIEW_ACCOUNT_PLAN_CHANGE_LINK: msg`Ändra`,
  ACCOUNT_VIEW_ACCOUNT_PLAN_RENEWAL_FREQUENCY: msg`Förnyas`,
  ACCOUNT_VIEW_ACCOUNT_PLAN_RENEWAL_YEARLY: msg`Årsvis`,
  ACCOUNT_VIEW_ACCOUNT_PLAN_RENEWAL_MONTHLY: msg`Månadsvis`,
  ACCOUNT_VIEW_ACCOUNT_PLAN_RENEWAL_CUSTOM: msg`Anpassad`,
  ACCOUNT_VIEW_ACCOUNT_PLAN_EXPIRES_AT: msg`Utgångsdatum`,
  ACCOUNT_VIEW_ACCOUNT_AVAILABLE_SOURCES: msg`Medietyper`,
  ACCOUNT_VIEW_ACCOUNT_SETTINGS_TITLE: msg`Organisationsinställningar`,

  ACCOUNT_VIEW_ACCOUNT_AVAILABLE_LANGUAGES: msg`Språk`,
  ACCOUNT_VIEW_ACCOUNT_NAME_LABEL: msg`Namn på organisationen`,
  ACCOUNT_VIEW_ACCOUNT_NAME_SAVE: msg`Spara namn`,
  ACCOUNT_VIEW_ACCOUNT_NAME_REQUIRED: msg`Organisationen måste ha ett namn`,
  ACCOUNT_VIEW_ACCOUNT_NAME_SAVED: msg`Namnet har uppdaterats`,
  ACCOUNT_VIEW_ACCOUNT_NAME_ERROR_TITLE: msg`Något gick fel`,
  ACCOUNT_VIEW_ACCOUNT_NAME_ERROR: msg`Namnet kunde inte uppdateras, försök igen senare.`,
  ACCOUNT_VIEW_ACCOUNT_DELETE_TITLE: msg`Radera organisation`,
  ACCOUNT_VIEW_ACCOUNT_DELETE_PLAN_WARNING: msg`Du har ett aktivt abonnemang, avsluta det först.`,
  ACCOUNT_VIEW_ACCOUNT_DELETE_INFO: msg`Vi tar bort alla bevakningar, rapporter och användare kopplat till den här organisationen. Det här går inte att återkalla och all data går förlorad. Vill du radera organisationen?`,
  ACCOUNT_VIEW_ACCOUNT_DELETE_CONFIRM: msg`Ja, radera organisationen`,
  ACCOUNT_VIEW_ACCOUNT_DELETE_CANCEL: msg`Tillbaka`,
  ACCOUNT_VIEW_ACCOUNT_DELETE_ARE_YOU_SURE: msg`Är du säker?`,
  ACCOUNT_VIEW_ACCOUNT_DELETE_ERROR_TITLE: msg`Misslyckades att radera kontot`,
  ACCOUNT_VIEW_ACCOUNT_DELETE_ERROR: msg`Försök igen senare eller kontakta kundtjänst`,
  ACCOUNT_VIEW_ACCOUNT_CURRENCIES_SEK: msg`Svenska kronor`,
  ACCOUNT_VIEW_ACCOUNT_CURRENCIES_DOLLAR: msg`US Dollar`,
  ACCOUNT_VIEW_ACCOUNT_CURRENCIES_NOK: msg`Norska kronor`,
  ACCOUNT_VIEW_ACCOUNT_CURRENCIES_EUR: msg`Euro`,

  ACCOUNT_VIEW_USAGE_HEADER: msg`Användning`,
  ACCOUNT_VIEW_USAGE_INTRO: msg`Här visas er användning och gränser för din aktuella prisplan. Hör av dig till kundservice för att utöka gränserna.`,
  ACCOUNT_VIEW_USAGE_MENTIONS_LABEL: msg`Omnämnanden`,
  ACCOUNT_VIEW_USAGE_MENTIONS_LABEL_WITH_PERIOD: msg`Omnämnanden denna månad`,
  ACCOUNT_VIEW_USAGE_MENTIONS_DETAILED_OF: msg`av`,
  ACCOUNT_VIEW_USAGE_MENTIONS_DETAILED_THIS_MONTH: msg`denna månad`,
  ACCOUNT_VIEW_USAGE_MENTIONS_SOCIAL_MEDIA_LABEL: msg`Omnämnanden i sociala medier`,
  ACCOUNT_VIEW_USAGE_MENTIONS: msg`Omnämnanden`,
  ACCOUNT_VIEW_USAGE_USERS: msg`Användare`,
  ACCOUNT_VIEW_USAGE_USERS_MANAGE: msg`Hantera`,
  ACCOUNT_VIEW_USAGE_ALERTS: msg`Bevakningar`,
  ACCOUNT_VIEW_USAGE_REPORTS: msg`Analysrapporter`,

  ACCOUNT_MENTIONS_HEADER: msg`Bevakningar`,
  ACCOUNT_MENTIONS_INTRO: msg`Aktiva bevakningar som genererar omnämnanden.`,
  ACCOUNT_MENTIONS_TABLE_TITLE: msg`Namn`,
  ACCOUNT_MENTIONS_TABLE_MENTIONS: msg`Antal omnämnanden skapade denna månad`,
  ACCOUNT_MENTIONS_TABLE_SHOW: msg`Visa`,
  ACCOUNT_MENTIONS_TABLE_PRIO_FAILED: msg`Sökningen kunde inte prioriteras.`,
  ACCOUNT_MENTIONS_TABLE_TOOLTIP: msg`Prioriterade bevakningar får extra resurser av systemet. Obs: är alla bevakningar prioriterade är det som att ingen är prioriterad, så välj gärna så få som möjligt.`,
  COPIED_TO_CLIPBOARD: msg`Kopierad till urklipp`,
  SHARE_MODAL_COPY_URL: msg`Kopiera`,
  SHARE_MODAL_COPY_URL_SUCCESS: msg`Kopierat!`,
  SHARE_MODAL_MENTION_PUBLIC_LINK: msg`Publik länk för omnämnande`,
  SHARE_MODAL_SHARE_TEXT: msg`Offentliga länkar kan ses av alla. Kopiera en länk för att dela detta omnämnande.`,
  HELP_ARTICLE_REACH: msg`https://help.allears.ai/sv/articles/3765637-hur-fungerar-rackvidd`,
  HELP_ARTICLE_ENGAGEMENT: msg`https://help.allears.ai/sv/articles/5579630-hur-fungerar-engagemang`,
  HELP_ARTICLE_PR_VALUE: msg`https://help.allears.ai/sv/articles/3765736-vad-betyder-pr-varde-och-hur-raknas-det-ut`,
  HELP_ARTICLE_POPULARITY: msg`https://help.allears.ai/en/articles/6622235-what-is-popularity-score`,
  HELP_ARTICLE_PEST: msg`https://help.allears.ai/sv/articles/8414770-vad-ar-en-pest-analys`,
  HELP_ARTICLE_NET_SENTIMENT: msg`https://help.allears.ai/sv/articles/9099849-vad-ar-nettosentiment`,
  SHARE_TAG_MODAL_TITLE: msg`Dela omnämnanden taggade som {}`,
  EXPORT_TAG_MODAL_TITLE: msg`Exportera omnämnanden taggade som {}`,
  SHARE_TAG_MODAL_RSS: msg`RSS feed för omnämnanden`,
  SHARE_FAVORITES: msg`Dela favoriter`,
  EXPORT_FAVORITES: msg`Exportera favoriter`,

  SHARE_ALERT_MODAL_TITLE: msg`Dela {}`,
  SHARE_ALERT_MODAL_LEDE: msg`Offentliga länkar kan ses av alla. Kopiera en länk för att dela.`,
  SHARE_ALERT_MODAL_MENTIONS: msg`Publik länk för omnämnanden`,
  SHARE_ALERT_MODAL_ANALYTICS: msg`Publik länk för analys`,

  EXPORT_ALERT_MODAL_TITLE: msg`Exportera {}`,
  EXPORT_ALERT_MODAL_MENTIONS: msg`Omnämnanden`,
  EXPORT_ALERT_MODAL_ANALYTICS: msg`Analys`,

  SHARE_ALERT_MODAL_EXPORT_DESCRIPTION: msg`Ladda ner den här bevakningen som Excel, CSV eller text-dokument.`,
  SHARE_ALERT_MODAL_EXPORT_DESCRIPTION_EXCEL_ONLY: msg`Ladda ner den här bevakningen som Excel eller CSV.`,
  SHARE_ALERT_MODAL_SHARE_TAB_TITLE: msg`Delbar länk`,
  SHARE_ALERT_MODAL_SHARE_DESCRIPTION: msg`Dela den här bevakningen genom att kopiera ett länkalternativ nedan.`,
  SETTINGS_TITLE: msg`Inställningar`,
  USER_SETTINGS_TITLE: msg`Min profil`,
  USER_SETTINGS_SAVE: msg`Spara ändringar`,
  USER_SETTINGS_EMAIL_TITLE: msg`Mejlutskick`,
  USER_SETTINGS_PASSWORD_TITLE: msg`Lösenord`,
  USER_SETTINGS_NEW_PASSWORD_TITLE: msg`Lösenord`,
  USER_SETTINGS_NEW_PASSWORD_CHANGE: msg`Ändra lösenord`,
  USER_SETTINGS_VALIDATION_PASSWORD_TOO_SHORT: msg`Lösenordet måste vara minst 8 tecken långt`,
  USER_SETTINGS_VALIDATION_PASSWORD_MISSING_NUMBER: msg`Lösenordet måste innehålla minst 1 siffra`,
  USER_SETTINGS_PASSWORD_AGAIN: msg`Bekräfta nytt lösenord`,
  USER_SETTINGS_PASSWORD_SAVE: msg`Byt Lösenord`,
  USER_SETTINGS_FIELDS_EMAIL_PLACEHOLDER: msg`user@example.com`,
  USER_SETTINGS_DELETE_TITLE: msg`Radera min profil`,
  USER_SETTINGS_DELETE_DESCRIPTION: msg`Du kan inte ta bort din profil eftersom du är den enda administratören för denna organisation, radera organisation istället. Du loggas ut och vi raderar din användare permanent, är du säker på att du vill radera den?`,
  USER_SETTINGS_DELETE_CTA: msg`Radera profil`,
  USER_SETTINGS_API_TOKEN_TITLE: msg`API nyckel`,

  API_TOKEN_CREATED: msg`API nyckel skapad`,
  API_TOKEN_ERROR_CREATING: msg`Misslyckades med att skapa API nyckel`,
  API_TOKEN_DELETED: msg`API nyckel raderad`,
  API_TOKEN_ERROR_DELETING: msg`Misslyckades med att radera API nyckel`,
  API_TOKEN_CONFIRM_DELETE: msg`Är du säker på att du vill radera API nyckeln?`,
  API_TOKEN_DESCRIPTION: msg`Använd den här nyckeln för att autentisera dig mot All Ears API.`,
  API_TOKEN_DELETE: msg`Radera API nyckel`,
  API_TOKEN_VIEW: msg`Visa API nyckel`,
  API_TOKEN_HIDE: msg`Göm API nyckel`,
  API_TOKEN_CREATE: msg`Skapa API nyckel`,
  API_TOKEN_COPIED: msg`API nyckel kopierad`,
  API_TOKEN_ERROR_COPYING: msg`Misslyckades med att kopiera API nyckel`,

  SETTINGS_TAB_ME: msg`Min profil`,
  SETTINGS_TAB_ACCOUNT: msg`Organisation`,
  SETTINGS_TAB_USERS: msg`Användare`,

  EDIT_USER_MODAL_SEARCH_TITLE: msg`Bevakningsinställningar`,
  EDIT_USER_MODAL_REPORT_TITLE: msg`Rapportinställningar`,
  EDIT_USER_MODAL_TITLE: msg`Redigera användare`,
  EDIT_USER_MODAL_SAVE: msg`Spara`,

  USER_SETTINGS_GENERIC_NAME_LABEL: msg`Namn`,
  USER_SETTINGS_GENERIC_EMAIL_LABEL: msg`Mejladress`,
  USER_SETTINGS_GENERIC_LANGUAGE_LABEL: msg`Språk`,
  USER_SETTINGS_GENERIC_CURRENCY_LABEL: msg`Valuta`,
  USER_SETTINGS_GENERIC_CURRENCY_PLACEHOLDER: msg`Välj:`,
  USER_SETTINGS_GENERIC_TIMEZONE_LABEL: msg`Tidszon`,
  USER_SETTINGS_GENERIC_TIMEZONE_PLACEHOLDER: msg`Välj:`,
  USER_SETTINGS_GENERIC_REPORT_WEEKENDS: msg`Skicka mail på helger`,
  USER_SETTINGS_GENERIC_REPORT_TIME: msg`Tidpunkt för mailrapporter`,
  USER_SETTINGS_GENERIC_REPORT_TIME_DISCLAIMER: msg`Gäller mail på dag- och veckobasis`,
  THEME_TITLE: msg`Utseende`,
  THEME_SUBTITLE: msg`Välj tema`,
  THEME_LIGHT: msg`Ljust`,
  THEME_SYSTEM: msg`Automatisk`,
  THEME_DARK: msg`Mörkt`,

  ORGANIZATION_USERS_TITLE: msg`Användare`,
  ORGANIZATION_USERS_USER_DELETE_CONFIRM_TITLE: msg`Ta bort användare`,
  ORGANIZATION_USERS_USER_DELETE_CONFIRM_MESSAGE: msg`Är du säker på att du vill ta bort {}?`,
  ORGANIZATION_USERS_USER_DELETED: msg`Användaren har tagits bort`,
  ORGANIZATION_USERS_USER_DELETE_FAILURE: msg`Misslyckades med att ta bort användaren.`,
  ORGANIZATION_USERS_SUBTITLE: msg`Få en översikt av kontots användare och redigera deras profiler härifrån.`,
  ORGANIZATION_USERS_INVITE: msg`Bjud in kollega`,
  ORGANIZATION_USERS_COL_NAME: msg`Namn`,
  ORGANIZATION_USERS_COL_TYPE: msg`Status`,
  ORGANIZATION_USERS_COL_ADDED: msg`Tillagd`,
  ORGANIZATION_USERS_CHANGE_USER_SETTINGS: msg`Ändra inställningar`,
  ORGANIZATION_USERS_READONLY: msg`Endast läsåtkomst`,

  ORGANIZATION_INVITE_USER_TITLE: msg`Bjud in en kollega`,
  ORGANIZATION_INVITE_SEND: msg`Skicka inbjudan`,
  ORGANIZATION_INVITE_NEXT_STEP: msg`Nästa`,
  ORGANIZATION_INVITE_PREVIOUS_STEP: msg`Tillbaka`,
  ORGANIZATION_INVITE_USER_SUBTITLE: msg`Lägg till en kollega som ska kunna ta del av omnämnanden, mejlrapporter och analyser.`,
  ORGANIZATION_INVITE_USER_EMAIL_LABEL: msg`Mejladress`,
  ORGANIZATION_INVITE_USER_EMAIL_PLACEHOLDER: msg`Mejladress`,
  ORGANIZATION_INVITE_USER_ACCESS_LEVEL: msg`Åtkomstnivå`,
  ORGANIZATION_INVITE_USER_ACCESS_LEVEL_HELPER: msg`Läs mer om åtkomstnivåer`,
  ORGANIZATION_INVITE_USER_ACCESS_LEVEL_HELPER_LINK: msg`https://help.allears.ai/sv/articles/7896568-vad-innebar-accessnivaerna`,
  ORGANIZATION_INVITE_USER_TYPE: msg`Typ`,
  ORGANIZATION_INVITE_USER_NAME: msg`Namn`,
  ORGANIZATION_INVITE_USER_SUBSCRIBE: msg`Skickas per mejl`,
  ORGANIZATION_INVITE_USER_SEARCH_SUBSCRIPTIONS_TITLE: msg`Välj vilka bevakningar din kollega ska se`,
  ORGANIZATION_INVITE_USER_SEARCH_SUBSCRIPTIONS_SUBTITLE_READONLY: msg`Med läsrättigheter får din kollega mejlrapporter och kan logga in och se de bevakningar som den prenumererar på.`,
  ORGANIZATION_INVITE_USER_SEARCH_SUBSCRIPTIONS_SUBTITLE_USER: msg`De här inställningarna kan alltid ändras i appen.`,
  ORGANIZATION_INVITE_USER_REPORT_SUBSCRIPTIONS_TITLE: msg`Välj vilka rapporter din kollega ska få`,
  ORGANIZATION_INVITE_USER_SUCCESS: msg`Inbjudan har skickats`,
  ORGANIZATION_INVITE_USER_FAILURE: msg`Misslyckades`,
  ORGANIZATION_INVITE_USER_INVITE_TITLE: msg`Bjud in din kollega`,

  ORGANIZATION_USER_SEARCH_TABLE_TITLE: msg`Namn`,
  ORGANIZATION_USER_REPORT_TABLE_TITLE: msg`Rapport`,
  ORGANIZATION_USER_REPORT_TABLE_INTERVAL: msg`Skickas per mejl`,

  LICENSES_TITLE: msg`Licenser`,

  PUBLIC_MENTION_UNKNOWN_INSTAGRAM_USER: msg`Instagram-användare`,
  PUBLIC_MENTION_SUBTITLE: msg`Här är ett omnämnande från All Ears`,

  PUBLIC_ALERT_SUBTITLE: msg`Det här är ett urval av {} omnämnanden från All Ears`,
  PUBLIC_ALERT_EMPTY_SUBTITLE: msg`Det finns inga omnämnanden att visa just nu.`,
  CAUGHT_UP_NOTICE_HEADLINE: msg`Du är uppdaterad!`,
  CAUGHT_UP_NOTICE_BODY: msg`Du har sett alla omnämnanden sedan du var här sist.`,
  REQUIRED_FIELD_VALUE: msg`Måste anges`,

  LOGIN_TITLE: msg`Välkommen till All Ears`,

  SAMPLE_REPORT_CTA: msg`Se alla omnämnanden`,

  LOGIN_SUBTITLE: msg`Logga in för att ta del av dina bevakningar och omnämnanden.`,
  LOGIN_FORGOT_PASSWORD: msg`Har du glömt ditt lösenord?`,
  LOGIN_CTA: msg`Logga in`,
  LOGIN_EMAIL: msg`E-postadress`,
  LOGIN_PASSWORD: msg`Lösenord`,
  LOGIN_DIVIDER: msg`Eller`,
  LOGIN_CTA_GOOGLE: msg`Fortsätt med Google`,
  LOGIN_CTA_MICROSOFT: msg`Fortsätt med Microsoft`,
  LOGIN_PASSWORD_PLACEHOLDER: msg`Ditt lösenord`,
  LOGIN_EMAIL_PLACEHOLDER: msg`Fyll i din e-postadress`,
  INVALID_EMAIL: msg`Ogiltig e-postadress`,
  OAUTH_PERSONAL_EMAIL_ERROR: msg`Ange din e-post för jobbet, inte Gmail, Hotmail eller andra privata e-postadresser.`,
  OAUTH_LOGIN_FAIL_ALERT_FIRST: msg`Användaren hittades inte. Kontrollera att du loggar in med rätt uppgifter eller`,
  OAUTH_LOGIN_FAIL_ALERT_A_TAG: msg`kontakta vår support`,
  OAUTH_LOGIN_FAIL_ALERT_LAST: msg` om du behöver hjälp.`,

  ACTIVATE_NAME_PLACEHOLDER: msg`Ditt för- och efternamn`,
  ACTIVATE_NAME_LABEL: msg`Fullständigt namn`,
  ACTIVATE_EMAIL_LABEL: msg`E-postadress`,
  ACTIVATE_CTA: msg`Aktivera konto`,
  ACTIVATE_PASSWORD_PLACEHOLDER: msg`Lösenord`,
  ACTIVATE_PASSWORD_LABEL: msg`Nytt lösenord`,
  ACTIVATE_PASSWORD_VERIFY_PLACEHOLDER: msg`Lösenord`,
  ACTIVATE_PASSWORD_VERIFY_LABEL: msg`Verifiera lösenord`,
  ACTIVATE_PASSWORD_VERIFY_MISMATCH: msg`Lösenorden matchar inte`,
  ACTIVATE_LAST_NAME_MISSING: msg`Efternamn saknas`,

  ACTIVATE_TITLE: msg`Aktivera ditt konto`,

  ACTIVATE_LOADING: msg`Aktivera ditt konto för att ta del av dina omnämnaden`,
  ACTIVATE_LOADING_TITLE: msg`Vi skapar ditt konto`,
  ACTIVATE_LOADING_SUBTITLE: msg`Visste du att 52% av all media som konsumeras i Sverige är talad?`,
  ONBOARDING_TITLE: msg`Hej {}, välkommen till All Ears!`,
  ONBOARDING_BODY_TEXT: msg`All Ears hjälper dig att bevaka medielandskapet och notifierar dig så fort ditt varumärke omnämns. Det är superenkelt att spela upp dina omnämnanden, testa själv.`,
  ONBOARDING_FINISH_CTA: msg`Fortsätt till All Ears`,

  PASSWORD_LENGTH_VALIDATOR_FAIL: msg`Måste vara minst 8 tecken långt`,
  PASSWORD_NON_NUMERICAL_VALIDATOR_FAIL: msg`Får inte enbart bestå av siffror`,
  DATE_THIS_MONTH: msg`Denna månad`,
  DATE_PREVIOUS_MONTH: msg`Föregående månad`,
  LAST_30_DAYS: msg`Senaste 30 dagarna`,
  LAST_7_DAYS: msg`Senaste 7 dagarna`,
  THIS_YEAR: msg`Detta år`,
  PREVIOUS_YEAR: msg`Föregående år`,
  LATEST_24_HOURS: msg`Senaste 24 h.`,
  LATEST_3_MONTHS: msg`Senaste 3 mån.`,
  DATE_CUSTOM: msg`Välj datum`,
  DATE_CUSTOM_START_LABEL: msg`Startdatum`,
  DATE_CUSTOM_END_LABEL: msg`Slutdatum`,
  ALL_TIME: msg`Alla träffar`,

  EXPLORE_TITLE: msg`Arkivsök`,
  EXPLORE_ADVANCED_CTA: msg`Visa avancerade sökalternativ`,
  EXPLORE_QUERY_ADD: msg`Lägg till söksats`,
  EXPLORE_DATES: msg`Datumintervall`,
  EXPLORE_QUERY_REMOVE: msg`Ta bort söksats`,
  EXPLORE_CHANNEL_TYPE: msg`Typ av omnämnanden`,
  EXPLORE_SOURCES: msg`Medietyper`,
  EXPLORE_CREATE_ALERT_CTA: msg`Skapa bevakning`,
  EXPLORE_SAVE_MENTIONS_CTA: msg`Spara sökresultat`,
  CREATE_ALERT_PREVIEW_TITLE: msg`Här är en förhandsvisning`,
  EXPLORE_PERFORM_SEARCH_CTA: msg`Sök`,
  EXPLORE_DISCLAIMER: msg`All the statistical data is based on and by All Ears compiled data including but not limited to YouTube related hits.`,
  EXPLORE_DESCRIPTION: msg`Sök i allt som All Ears har hört.`,
  EXPLORE_HELP: msg`Testa att söka på varumärken, konkurrenter, talespersoner eller branschbegrepp`,
  EXPLORE_KEYWORD_LABEL: msg`Sökord`,
  EXPLORE_KEYWORD_PLACEHOLDER: msg`Swedbank*`,
  EXPLORE_KEYWORD_NEAR_LABEL: msg`Nämns i samband med`,
  EXPLORE_KEYWORD_NEAR_HELP: msg`Tips! Använd stjärna (*) för att hitta ord med varierande ändelser.`,
  EXPLORE_KEYWORD_NEAR_PLACEHOLDER: msg`lån*, ränta*, amortering*`,
  EXPLORE_KEYWORD_NEAR_MAX_NEAR_LABEL: msg`Max antal ord ifrån`,
  EXPLORE_KEYWORD_NEAR_MAX_NOT_NEAR_LABEL: msg`Max antal ord ifrån`,
  EXPLORE_KEYWORD_EXCLUDE: msg`Uteslut ord`,
  EXPLORE_CHANNEL_INCLUDE: msg`Sök bara i källor med namn`,
  EXPLORE_CHANNEL_EXCLUDE: msg`Uteslut källor med namn`,
  EXPLORE_KEYWORD_EXCLUDE_PLACEHOLDER: msg`fond*, aktie*`,
  EXPLORE_CHANNEL_INCLUDE_PLACEHOLDER: msg`RikaTillsammans, Nyhetsmorgon`,
  EXPLORE_CHANNEL_EXCLUDE_PLACEHOLDER: msg`P4 Göteborg, Avanzapodden`,
  EXPLORE_NO_RESULTS: msg`Din sökning gav tyvärr inga träffar`,
  EXPLORE_RESULTS_COUNT: msg`Sökningen gav {} träffar`,
  EXPLORE_LANGUAGES: msg`Språk`,
  EXPLORE_NEW_ALERT: msg`Skapa bevakning`,
  EXPLORE_NEW_ALERT_FIELD_TITLE_LABEL: msg`Namn på bevakning`,
  EXPLORE_NEW_ALERT_FIELD_TITLE_PLACEHOLDER: msg`Namn på bevakning`,
  EXPLORE_NEW_ALERT_FIELD_TYPE_LABEL: msg`Vad ska du bevaka?`,
  EXPLORE_NEW_ALERT_FIELD_TYPE_PLACEHOLDER: msg`Välj från listan`,
  EXPLORE_NEW_ALERT_FIELD_START_LABEL: msg`Historik`,
  EXPLORE_NEW_ALERT_FIELD_START_PLACEHOLDER: msg`Automatisk`,
  EXPLORE_NEW_ALERT_FIELD_END_LABEL: msg`Slutdatum`,
  EXPLORE_NEW_ALERT_FIELD_END_PLACEHOLDER: msg`Tills vidare`,
  EXPLORE_NEW_ALERT_FIELD_SORTING_LABEL: msg`Sortering`,
  EXPLORE_NEW_ALERT_FIELD_SORTING_HELP: msg`Ange bevakningens ordning i menyn och mailutskick. Lägre värde sorteras högre upp.`,
  EXPLORE_NEW_ALERT_CREATE: msg`Skapa bevakning`,

  ALERT_TYPE_BRAND: msg`Varumärke`,
  ALERT_TYPE_ORGANIZATION: msg`Verksamhet`,
  ALERT_TYPE_INDUSTRY: msg`Bransch`,
  ALERT_TYPE_COMPETITOR: msg`Konkurrent`,
  ALERT_TYPE_SPOKESPERSON: msg`Person`,
  ALERT_TYPE_TOPIC: msg`Ämnesområde`,
  ALERT_TYPE_CAMPAIGN: msg`Kampanj`,
  ALERT_TYPE_OTHER: msg`Annat`,

  PUBLIC_LOGIN_BUTTON: msg`Logga in`,
  PUBLIC_EXAMPLE_SUBTITLE: msg`All Ears bevakar automatiskt när ditt varumärke omnämns i {} media. Här är några exempelträffar på ert varumärke:`,
  PUBLIC_CTA_TITLE: msg`Håll koll på vad som sägs om ditt varumärke`,
  PUBLIC_CTA_DESC: msg`All Ears är en revolutionerande AI-plattform som analyserar varumärkesomnämnanden och trender i det talade medielandskapet.`,
  PUBLIC_CTA_BOOK_DEMO: msg`Boka demo`,

  PUBLIC_FOOTER_PAGES_CAREER: msg`Karriär`,
  PUBLIC_FOOTER_PAGES_IN_ENGLISH: msg`In English`,
  PUBLIC_FOOTER_PAGES_IN_SWEDISH: msg`På svenska`,
  PUBLIC_FOOTER_PAGES_TERMS: msg`Allmänna villkor`,
  PUBLIC_FOOTER_PAGES_PRIVACY_POLICY: msg`Personuppgiftspolicy`,
  PUBLIC_FOOTER_PAGES_COOKIE_POLICY: msg`Cookiepolicy`,

  CREATE_ALERT_ADVANCED_INFO: msg`Behöver du skapa en mer avancerad bevakning?`,
  CREATE_ALERT_ADVANCED_LINK_PRE: msg`Eller gå till`,
  CREATE_ALERT_ADVANCED_LINK: msg`Avancerat läge`,
  CREATE_ALERT_POWER_USER_LINK: msg`Superavancerat™ läge`,
  CREATE_ALERT_SIMPLE_INFO: msg`Ta mig tillbaka till det enkla läget!`,
  CREATE_ALERT_SIMPLE_LINK: msg`Enkelt läge`,

  SIGN_UP_TITLE: msg`Skapa konto`,
  SIGN_UP_PERSONAL_INFO_TITLE: msg`Skapa ditt konto`,
  SIGN_UP_ALTERNATIVE_TITLE: msg`Eller`,
  SIGN_UP_NEXT_STEP_CTA: msg`Nästa`,
  SIGN_UP_TERMS: msg`Genom att registrera dig godkänner du All Ears <a href=\"https://sv.allears.ai/allmanna-villkor\" target=\"_blank\">villkor</a> och <a href=\"https://sv.allears.ai/personuppgiftspolicy\" target=\"_blank\">integritetspolicy</a>.`,
  SIGN_UP_ORGANIZATION_INFO_TITLE: msg`Vad heter ditt företag?`,
  SIGN_UP_ORGANIZATION_NAME: msg`Företagsnamn`,
  SIGN_UP_FINISH_CTA: msg`Slutför`,
  SIGN_UP_ACTIVATION_SENT_TITLE: msg`Nästan klart!`,
  SIGN_UP_ACTIVATION_SENT_TEXT: msg`Vi har skickat ett mejl till {}. Verifiera ditt konto för att logga in i All Ears`,
  SIGN_UP_UNKNOWN_ERROR_MESSAGE: msg`Vi kunde inte skapa ditt konto just nu, försök igen lite senare.`,
  ROLE_NAME_ADMIN: msg`Admin`,
  ROLE_NAME_USER: msg`Användare`,
  ROLE_NAME_READONLY: msg`Begränsad användare`,

  ROLE_NAME_ADMIN_PLURAL: msg`Admins`,
  ROLE_NAME_USER_PLURAL: msg`Användare`,
  ROLE_NAME_READONLY_PLURAL: msg`Begränsade användare`,

  USER_STATUS_ACTIVE: msg`Aktiverad`,
  USER_STATUS_INVITED: msg`Inbjuden`,

  ROLE_DESCRIPTION_ADMIN: msg`Kan redigera organisationsinställningar och hantera användare.`,
  ROLE_DESCRIPTION_USER: msg`Kan skapa nya bevakningar, rapporter och bjuda in kollegor.`,
  ROLE_DESCRIPTION_READONLY: msg`Kan se utvalda bevakningar och rapporter. Har inte tillgång till att redigera inställningar.`,
  STATUS_PAGE_NOT_ALLOWED_TITLE: msg`Du saknar åtkomst`,
  STATUS_PAGE_NOT_ALLOWED_SUBTITLE: msg`Kontakta din kontoadministratör eller kundtjänst`,
  STATUS_PAGE_NOT_FOUND_TITLE: msg`Sidan hittades inte`,
  STATUS_PAGE_NOT_FOUND_SUBTITLE: msg`404`,
  STATUS_PAGE_TAG_NOT_FOUND_TITLE: msg`Taggen “{}“ hittades inte.`,

  TAGS_EMPTY_TITLE: msg`Taggar`,
  TAGS_EMPTY_SUBTITLE: msg`Kategorisera och strukturera dina omnämnanden med taggar.`,
  FAVORITES_EMPTY_TITLE: msg`Favoriter`,
  FAVORITES_EMPTY_SUBTITLE: msg`Favoritmarkera omnämnanden för att se dem här.`,
  ARCHIVE_EMPTY_TITLE: msg`Avslutade bevakningar`,
  ARCHIVE_EMPTY_SUBTITLE: msg`Här hamnar dina bevakningar när dom är avslutade.`,
  SAVED_SEARCH_EMPTY_TITLE: msg`Sparade sökningar`,
  SAVED_SEARCH_EMPTY_SUBTITLE: msg`Här hamnar dina sparade sökningar från arkivsök.`,
  CONTACT_SALES_MODAL_TITLE: msg`Kontakta vår säljavdelning`,
  CONTACT_SALES_MODAL_SUBTITLE: msg`Enterprise`,
  CONTACT_SALES_NAME_LABEL: msg`Namn`,
  CONTACT_SALES_EMAIL_LABEL: msg`Email`,
  CONTACT_SALES_MESSAGE_LABEL: msg`Hur vill du använda All Ears?`,
  CONTACT_SALES_MESSAGE_PLACEHOLDER: msg`T.ex. jag vill ha obegränsat med bevakningar`,
  CONTACT_SALES_MESSAGE_SEND: msg`Skicka`,
  CONTACT_SALES_MESSAGE_CONFIRMATION_TITLE: msg`Tack!`,
  CONTACT_SALES_MESSAGE_CONFIRMATION_SUBTITLE: msg`Vi återkommer strax med mer information om All Ears.`,
  CONTACT_SALES_MESSAGE_ERROR: msg`Ditt meddelande kunde inte skickas. Försök igen.`,
  SELECT_ALL: msg`Välj alla`,

  QB_POWER_MODE_CTA: msg`Applicera`,
  QB_POWER_MODE_JSON_PLACEHOLDER: msg`Klistra in bevakningens JSON här`,

  DASHBOARD_TITLE: msg`Hej, {}!`,

  DASHBOARD__GETTING_STARTED__TITLE: msg`Kom igång med All Ears`,
  DASHBOARD__GETTING_STARTED__CONTROLS__BROWSE_PREVIOUS: msg`Föregående`,
  DASHBOARD__GETTING_STARTED__CONTROLS__BROWSE_NEXT: msg`Nästa`,

  DASHBOARD__GETTING_STARTED__FOUNDATIONS__TITLE: msg`Lär dig grunderna i All Ears på bara några minuter`,
  DASHBOARD__LATEST_MENTIONS__TITLE: msg`Dina senaste omnämnanden`,

  DASHBOARD__COLLEAGUES__TITLE: msg`Dina kollegor`,
  DASHBOARD__COLLEAGUES__LAST_LOGGED_IN__TITLE: msg`Senast inloggade:`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__TITLE: msg`Senaste aktiviteter:`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__CREATED_REPORT: msg`sparade sökresultat`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__CREATED_ALERT: msg`skapade en bevakning`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__DELETED_ALERT: msg`raderade en bevakning`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__EDITED_ALERT: msg`ändrade en bevakning`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__SAVE_MENTIONS: msg`sparade sökresultat`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__EXPORT_MENTIONS_TO_EXCEL: msg`exporterade en bevakning till Excel`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__EXPORT_MENTIONS_TO_CSV: msg`exporterade en bevakning till csv`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__SHARED_MENTION: msg`delade ett omnämnande`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__MARKED_MENTION_RELEVANT: msg`återställde ett omnämnande`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__MARKED_MENTION_IRRELEVANT: msg`tog bort ett omnämnande`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__ADDED_MENTION_TAG: msg`taggade ett omnämnande`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__REMOVED_MENTION_TAG: msg`tog bort en tagg`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__PLAYED_MENTION: msg`lyssnade på ett omnämnande`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__DID_SEARCH: msg`använde arkivsök`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__LOGGED_IN: msg`loggade in`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__INVITED_COLLEAGUE: msg`bjöd in användare`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__USER_ACTIVATED: msg`:s konto aktiverades`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__SETTINGS_UPDATED: msg`:s konto uppdaterades`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__USER_DELETED: msg`:s konto togs bort`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__CREATED_REPORT_FROM_TEMPLATE: msg`skapade en rapport`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__PDF_GENERATED: msg`ladda ner en rapport`,
  DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__EDIT_REPORT: msg`ändrade en rapport`,
  DASHBOARD__ARTICLES__TITLE: msg`Hjälpartiklar`,
  DASHBOARD__ARTICLES__DESC: msg`Här hittar du svaren på några av de vanligaste frågorna som vi får`,
  DASHBOARD__GUIDE_MODAL__NEXT_GUIDE: msg`Nästa guide`,

  GENERIC_ERROR: msg`Någonting gick fel, försök igen.`,
  GENERIC_ERROR_LEDE: msg`Något stämmer inte riktigt här. Försök igen senare. Om det fortfarande inte fungerar, kontakta vår supportpersonal.`,
  ERROR: msg`Felmeddelande`,

  SOURCE_TYPE_PODCAST: msg`Podcast`,
  SOURCE_TYPE_RADIO: msg`Radio`,
  SOURCE_TYPE_TV: msg`TV`,
  SOURCE_TYPE_YOUTUBE: msg`YouTube`,
  SOURCE_TYPE_YOUTUBE_SHORTS: msg`YouTube Shorts`,
  SOURCE_TYPE_WEB_TV: msg`Webb-TV`,
  SOURCE_TYPE_MANUAL: msg`Manuell`,
  SOURCE_TYPE_FACEBOOK: msg`Facebook`,
  SOURCE_TYPE_INSTAGRAM: msg`Instagram`,
  SOURCE_TYPE_TIKTOK: msg`TikTok`,
  SOURCE_TYPE_TWITTER: msg`X`,
  SOURCE_TYPE_LINKEDIN: msg`LinkedIn`,
  SOURCE_TYPE_NEWS: msg`Nyhetsartikel`,

  SOURCE_TYPE_PLURAL_PODCAST: msg`Podcasts`,
  SOURCE_TYPE_PLURAL_MANUAL: msg`Manuella`,
  SOURCE_TYPE_PLURAL_NEWS: msg`Nyhetsartiklar`,

  OR: msg`Eller`,
};

export const L: Record<string, string> = new Proxy(
  {},
  {
    get: (_target, key: string) => {
      if (key in MESSAGES) {
        return i18n._(MESSAGES[key as keyof typeof MESSAGES]);
      }
      return null;
    },
  }
);

interface GlobalWithL extends Window {
  L: Record<string, string>;
}

(window as unknown as GlobalWithL).L = L;

export default L;
